window.Lemonade = window.Lemonade || {};

// Custom Handlebars JS Helper for increasing loop index by 1
Handlebars.registerHelper("inc", function(value, options){
  return parseInt(value) + 1;
});

Handlebars.registerHelper('ifAnd', function (a, b, options) {
  if (!!a && !!b) {
    return options.fn(this);
  }
  return options.inverse(this);
});

Handlebars.registerHelper('ifAndAnd', function (a, b, c, options) {
  if (!!a && !!b && !!c) {
    return options.fn(this);          // Render block if all true
  }
  return options.inverse(this);       // Render {{else}} or nothing
});

Handlebars.registerHelper('not', function (value) {
  return !value;
});

const SHIP_DATE_COOKIE_KEY = 'cartShipDate';
const SHIP_WINDOW_COOKIE_KEY = 'cartShipWindow';
const clearShipDateCookie = () => Cookies.remove(SHIP_DATE_COOKIE_KEY);
const clearShipWindowCookie = () => Cookies.remove(SHIP_WINDOW_COOKIE_KEY);

// API for utility functions
var Utilities = (function() {
  
  return {
  
    addProductsToCart: function(productQueue){
      if (productQueue.length) {
        var data = productQueue.shift();
        $.ajax({ url: '/cart/add.js', type: 'post', dataType: 'json',
          data: data,
          success: function(data, textStatus, jqXHR) {
            Utilities.addProductsToCart(productQueue);
          },
          error: function(jqXHR, textStatus, errorThrown) {
            errorCallback && errorCallback(jqXHR.responseJSON.description);
          }
        });
      } else {
        // Utilities.updateCart();
        location.reload();
      }
    },

    // Batch-add cart items in a way that works for both CSV imports and order rehydrates.
    // The helper works on a local copy so callers can keep their original item arrays intact.
    addProductsToCartBatched: async function (
      productQueue = [],
      completeCallback,
      errorCallback,
      batchSize = 20,
      maxRetries = 5,
      permanentFailureCallback
    ) {
      const queue = Array.isArray(productQueue)
        ? productQueue.map((item) => ({ ...item }))
        : [];
      const sleep = (ms) => new Promise((res) => setTimeout(res, ms));
      let lastFailureMessage = "Unknown error";

      const sendBatch = async (batch, attempt = 0, delay = 500) => {
        try {
          console.log(`➕ Adding batch of ${batch.length} items to cart...`);

          await $.ajax({
            url: '/cart/add.js',
            type: 'post',
            dataType: 'json',
            contentType: 'application/json',
            data: JSON.stringify({ items: batch }),
          });

          return true; // ✅ Success
        } catch (jqXHR) {
          const status = jqXHR.status;
          const msg = jqXHR.responseJSON?.description || "Unknown error";

          if (status === 429 && attempt < maxRetries) {
            console.warn(
              `⚠️ Rate limited (429). Retrying in ${delay}ms... (attempt ${
                attempt + 1
              }/${maxRetries})`
            );
            await sleep(delay);
            return sendBatch(batch, attempt + 1, delay * 2); // 🔁 Exponential backoff
          } else {
            lastFailureMessage = msg;
            console.error(`❌ Failed to add batch: ${msg}`);
            if (typeof errorCallback === "function") {
              errorCallback(msg, batch);
            }
            return false; // ❌ Permanent failure
          }
        }
      };

      while (queue.length) {
        const batch = queue.splice(0, batchSize);

        const success = await sendBatch(batch);
        if (!success && batchSize > 1) {
          console.warn(`🔄 Retrying batch individually (batchSize = 1)...`);
          // Retry each individually if the batch fails entirely
          for (const item of batch) {
            const itemAdded = await sendBatch([item]);
            if (!itemAdded && typeof permanentFailureCallback === "function") {
              permanentFailureCallback(lastFailureMessage, [item]);
            }
          }
        } else if (!success && typeof permanentFailureCallback === "function") {
          permanentFailureCallback(lastFailureMessage, batch);
        }

        await sleep(150); // Small throttle between batches to prevent constant 429s
      }

      console.log("✅ All items added to cart!");

      // ✅ Get final cart state and return
      const finalCart = await fetch("/cart.js").then((res) => res.json());
      if (typeof completeCallback === "function") {
        completeCallback(finalCart, []);
      }
    },

    updateCartQuantity: function(data, successCallback, errorCallback){
      $.ajax({
        url: '/cart/change.js',
        type: 'post',
        dataType: 'json',
        data: data,
        success: function(cart) {
          Utilities.updateCart(cart, true);
        },
        error: function(XMLHttpRequest, textStatus) {
          Shopify.onError(XMLHttpRequest, textStatus);
        }
      }); 
    },

    updateCart: function(){
      $.getJSON('/cart.js', function(cart){
        if (cart.items.length === 0){
          $('.prebookCart').hide();
          $('#dateShip').val('');
          $('.cart--notes--textarea').val('');
          $('.cart--notes').val('');
          // date cancel is temporarily disabled in the UI
          //$('.dateCancel').val('');
          $('body').removeClass('prebookItemsInCart');
        }
      });
    },

    changeCart: function(cartItemsQueue){
      if (cartItemsQueue.length) {
        var data = cartItemsQueue.shift();
        $.ajax('cart/change.js', {
          data: data,
          dataType: 'json',
          success: function(cart){
            Utilities.changeCart(cartItemsQueue);
          }
        })
      } else {
        window.location.reload();
      }
    },
    
    // TODO: Delete this once fully confirmed no problem with Promise version
    // clearCart: function(callback){
    //     $.ajax({
    //         type: "POST",
    //         url: '/cart/clear.js',
    //         dataType: 'json',
    //         success: function(){
    //           if(callback != false) window.location.reload();
    //         }
    //     });            
    // },

    clearCart: function(callback) {
      return new Promise((resolve, reject) => {
        $.ajax({
          type: "POST",
          url: "/cart/clear.js",
          dataType: "json",
          success: function() {
            console.log("✅ Cart successfully cleared");
            if (callback !== false) {
              // Legacy behavior (reload the page)
              window.location.reload();
            }
            resolve(); // ✅ Resolve when done
          },
          error: function(err) {
            console.error("❌ Cart clear failed:", err);
            reject(err);
          }
        });
      });
    },

  
  }

})();

// Global selectors and values
Lemonade.cacheSelectors = function(){

	Lemonade.cache = {
		
		// General
		$win: $(window),
		$body: $('html,body')
		    		
	};
	
};

// Kick off functions
Lemonade.init = function(){
  Lemonade.cacheSelectors();
  Lemonade.removeShipDateCookieIfLoggedOut();
  Lemonade.bindLogoutCookieClear();
  Utilities.updateCart();
  Lemonade.accordions();
  Lemonade.promiseDate();
  if(liquidVarsChat.chatType == 'module') {
    Lemonade.chatModule();
  }
  Lemonade.customOrdering(program1EnabledAndActive, program2EnabledAndActive);
  // Lemonade.productQuantity();
  Lemonade.clearCart();
  Lemonade.clearCookies();
};

Lemonade.clearCart = function(){
  const cartClearButton = document.getElementById('clear-the-cart');
  cartClearButton.addEventListener('click', Utilities.clearCart);
};

  Lemonade.clearCookies = () => {
    const cartCookiesButton = document.getElementById('clear-the-cookies');
    if (!cartCookiesButton) return;

    cartCookiesButton.addEventListener('click', ()=> {
      // Clear both cookie namespaces so the legacy and single_program cart
      // rehydrate paths stay aligned after a manual cookie reset.
      [
        'prebookProgram',
        'prebookProgramId',
        'prebookOrderId',
        'activePrebookProgram',
        'activePrebookProgramId',
        'activePrebookOrderId',
        'customerName',
        'customerId',
        'customerUsePrebook',
        'openCart',
        SHIP_DATE_COOKIE_KEY
      ].forEach(Cookies.remove);
      setTimeout(() => {
        window.location.reload(); // Refresh the current page
      }, 300);
    });
  }

Lemonade.removeShipDateCookieIfLoggedOut = () => {
  if (!customerID) {
    clearShipDateCookie();
  }
};

Lemonade.bindLogoutCookieClear = () => {
  const clearOnLogout = () => clearShipDateCookie();
  const logoutBindAttr = 'shipDateLogoutBound';

  document.querySelectorAll('a[href*="/account/logout"]').forEach(link => {
    if (link.dataset[logoutBindAttr]) return;
    link.addEventListener('click', clearOnLogout);
    link.dataset[logoutBindAttr] = 'true';
  });

  document.querySelectorAll('form[action*="/account/logout"]').forEach(form => {
    if (form.dataset[logoutBindAttr]) return;
    form.addEventListener('submit', clearOnLogout);
    form.dataset[logoutBindAttr] = 'true';
  });
};


Lemonade.customOrdering = function(program1EnabledAndActive, program2EnabledAndActive){

  // Global prebook status for active user
  let activePrebookData;
  let activeCustomerId;
  let customerUsePrebook = false;
  const checkbox = document.getElementById('customerUsePrebook');
  const checkboxLabel = checkbox
    ? document.querySelector(`label[for="${checkbox.id}"]`)
    : null;
  const prebookIndicator = document.getElementById('prebook-indicator');
  const panelB2bCsvUpload = document.getElementById('panelB2bCsvUpload');
  const panelPrebookTools = document.getElementById('panelPrebookTools');
  const triggerB2bCsvUpload = document.getElementById('triggerB2bCsvUpload');
  const b2bCsvUploadForm = document.getElementById('b2b-csv-upload-form');
  const accountCsvUploadForm = document.getElementById('account-csv-upload-form');
  const prebookCart = document.getElementById('prebookCart');
  const b2bCart = document.getElementById('b2bCart');
  const isCompletedNonRepPrebook = () => {
    if (isRep || !Array.isArray(activePrebookData?.programs)) return false;

    return activePrebookData.programs.some(program =>
      ['complete', 'ordered'].includes(program?.state)
    );
  };
  const togglePromiseDateField = (isPrebookActive) => {
    document.querySelectorAll('[data-promise-date-field]').forEach((el) => {
      el.style.display = isPrebookActive ? 'none' : '';
    });
  };

  // Keep the cart UI aligned to the active customer mode so cart refreshes do not
  // reintroduce the wrong date picker for the current session.
  const isPrebookSessionActive = () => Cookies.get('customerUsePrebook') === 'true';

  const syncCartModeUI = () => {
    const usePrebook = isPrebookSessionActive();

    // Use a body-level mode flag so CSS can reliably show only the active cart UI
    // even after cart refreshes or theme scripts re-render the cart block.
    document.body.classList.toggle('prebookCartActive', usePrebook);

    document.querySelectorAll('.prebookCart').forEach((cartRoot) => {
      cartRoot.hidden = !usePrebook;
    });

    document.querySelectorAll('.b2bCart').forEach((cartRoot) => {
      cartRoot.hidden = usePrebook;
    });
  };

  const normalizeCompletedNonRepOrderingState = () => {
    if (!isCompletedNonRepPrebook()) return false;

    customerUsePrebook = false;
    Cookies.set('customerUsePrebook', false);
    [
      'prebookProgram',
      'prebookProgramId',
      'prebookOrderId',
      'activePrebookProgram',
      'activePrebookProgramId',
      'activePrebookOrderId'
    ].forEach(Cookies.remove);

    document.body.classList.remove(
      'prebookActive',
      'prebookCartActive',
      'repOrderActive',
      'activeProgram1',
      'activeProgram2'
    );

    if (checkbox) {
      checkbox.checked = false;
      checkbox.disabled = true;
    }

    togglePromiseDateField(false);
    panelPrebookTools?.classList.add('hide');
    panelB2bCsvUpload?.classList.remove('hide');
    triggerB2bCsvUpload?.classList.remove('hide');
    syncCartModeUI();

    return true;
  };

  const getActiveCartDateInput = (root = document) => {
    return isPrebookSessionActive()
      ? root.querySelector('.prebookCart .dateShip')
      : root.querySelector('.b2bCart #dateShipB2B');
  };

  // Is prebook using the legacy 2 Program bucket model or the new single program/2 Ship Window model?
  const singleMode = liquidVars.prebookMode === 'single_program' ? true : false;

  // Cache the live cart total so single-program tier logic can react to cart changes
  // without mutating the saved program JSON. This stays isolated to single_program mode.
  let latestCartTotal = 0;
  let lastSingleModeTierState = null;

  // Pull the Program 1 threshold settings from Theme Settings and normalize them into
  // numbers so the projected total can be compared against the admin-configured cutoffs.
  const getSingleModeThresholds = () => ({
    orderMinimum: Number(program1OrderTotalMin || 0),
    firstThreshold: Number(program1FirstDiscount || 0),
    secondThreshold: Number(program1SecondDiscount || 0)
  });

  // Refresh the cached cart total from Shopify so tier checks use the live cart state.
  const refreshLatestCartTotal = async () => {
    try {
      const cart = await fetch('/cart.js').then((res) => res.json());
      latestCartTotal = Number(cart?.total_price || 0);
      return latestCartTotal;
    } catch (error) {
      console.warn('Unable to refresh the live cart total for single_program tier checks.', error);
      return latestCartTotal;
    }
  };

  // Turn a tier state into a readable label so downgrade alerts can explain what changed.
  const describeSingleModeTier = (tierState) => {
    if (!tierState) return 'the current tier';

    if (tierState.tier >= 3) return 'tier 3 (3 allowed ship dates)';
    if (tierState.tier === 2) return 'tier 2 (2 allowed ship dates)';
    if (tierState.tier === 1) return 'tier 1 (1 allowed ship date)';

    return 'below the minimum program threshold';
  };

  // Alert only when the projected tier drops. This keeps intentional cart clears and
  // baseline rehydrates quiet while still warning the customer when a real downgrade happens.
  const maybeAlertSingleModeTierDowngrade = (previousTierState, nextTierState, suppressDowngradeAlert = false) => {
    if (!singleMode || suppressDowngradeAlert) return;
    if (!previousTierState || !nextTierState) return;
    if (nextTierState.tier >= previousTierState.tier) return;

    alert(
      `Your projected program total has changed. The order moved from ${describeSingleModeTier(previousTierState)} to ${describeSingleModeTier(nextTierState)}, so the available ship date options may have been updated to match the current program rules.`
    );
  };

  // Calculate the projected single-program total from the saved program data plus the
  // current cart total. When editing an existing order, subtract the saved order total
  // first so the projection reflects the edited version instead of double-counting it.
  const getProjectedSingleModeTotal = () => {
    const savedProgram = activePrebookData?.programs?.find((program) => program.programId === 1);
    const savedProgramTotal = Number(savedProgram?.programTotal || 0);
    const activeOrderIndex = Math.max(0, getSingleModeOrderPosition() - 1);
    const savedOrderFromProgram = savedProgram?.orders?.[activeOrderIndex] || null;
    const savedOrderTotal = Number(
      activeOrderData?.orderTotal
      || savedOrderFromProgram?.orderTotal
      || 0
    );
    const hasSavedOrderInSlot = Boolean(
      activeOrderData?.items?.length || savedOrderFromProgram?.items?.length
    );

    // When the cart is rehydrating an existing order, use the order slot inside the
    // saved program data as a fallback so we do not accidentally double-count order #3
    // (or any later edit slot) before the live activeOrderData reference is restored.
    if (hasSavedOrderInSlot && latestCartTotal > 0) {
      return Math.max(0, savedProgramTotal - savedOrderTotal + latestCartTotal);
    }

    return Math.max(0, savedProgramTotal + latestCartTotal);
  };

  // Convert the projected total into a tier that later UI steps can consume. The tier
  // thresholds remain driven by the Program 1 Theme Settings values.
  const getSingleModeTierState = () => {
    if (!singleMode) return null;

    const thresholds = getSingleModeThresholds();
    const projectedTotal = getProjectedSingleModeTotal();

    if (projectedTotal >= thresholds.secondThreshold) {
      return { projectedTotal, tier: 3, allowedShipDates: 3 };
    }

    if (projectedTotal >= thresholds.firstThreshold) {
      return { projectedTotal, tier: 2, allowedShipDates: 2 };
    }

    if (projectedTotal >= thresholds.orderMinimum) {
      return { projectedTotal, tier: 1, allowedShipDates: 1 };
    }

    return { projectedTotal, tier: 0, allowedShipDates: 0 };
  };

  // Use the active order slot to decide whether this order can create a new ship date
  // or must reuse one of the ship dates already established in the program.
  const getSingleModeOrderPosition = () => {
    const program = activePrebookData?.programs?.find((targetProgram) => targetProgram.programId === 1);
    const activeOrderIndex = program?.orders?.indexOf(activeOrderData);

    // Prefer the live order object when it is available because edit-mode rehydration can
    // briefly lag behind the cookie state during page refreshes.
    if (Number.isInteger(activeOrderIndex) && activeOrderIndex >= 0) {
      return activeOrderIndex + 1;
    }

    const orderIndex = Number.parseInt(`${activeOrder ?? 0}`, 10);
    return Number.isNaN(orderIndex) ? 1 : orderIndex + 1;
  };

  // Store the current projected tier on the cart DOM so later UI work can read it
  // without recalculating the thresholds in multiple places.
  const updateSingleModeTierMetadata = (options = {}) => {
    if (!singleMode || !isPrebookSessionActive()) return null;

    const {
      suppressDowngradeAlert = false,
      trackTierChange = true
    } = options;
    const previousTierState = lastSingleModeTierState;
    const tierState = getSingleModeTierState();
    const didNormalize = normalizeSingleModeShipDates(tierState.allowedShipDates);

    if (trackTierChange) {
      maybeAlertSingleModeTierDowngrade(previousTierState, tierState, suppressDowngradeAlert);
      lastSingleModeTierState = tierState;
    }

    document.querySelectorAll('.prebookCart').forEach((cartRoot) => {
      cartRoot.dataset.projectedProgramTotal = String(tierState.projectedTotal);
      cartRoot.dataset.projectedProgramTier = String(tierState.tier);
      cartRoot.dataset.allowedShipDateCount = String(tierState.allowedShipDates);
    });

    if (didNormalize) {
      setPrebookUI();
    }

    return tierState;
  };

  // Keep the cached cart total and the derived tier metadata in sync together.
  const refreshSingleModeTierState = async (options = {}) => {
    if (!singleMode || !isPrebookSessionActive()) return null;

    await refreshLatestCartTotal();
    return updateSingleModeTierMetadata(options);
  };

  // Build the list of ship dates already in use by the single program so later orders
  // can be constrained to the dates the program has already established.
  const getSingleModeShipDateOptions = () => {
    if (!singleMode) return [];

    const program = activePrebookData?.programs?.find((targetProgram) => targetProgram.programId === 1);
    const shipDates = (program?.orders || [])
      .map((order) => order?.dateShip || '')
      .filter(Boolean);

    return [...new Set(shipDates)].sort();
  };

  // Collapse excess ship dates onto the last allowed ship date whenever the current
  // tier can no longer support the number of dates already present in the program.
  const normalizeSingleModeShipDates = (allowedShipDates) => {
    if (!singleMode || allowedShipDates < 1) return false;

    const program = activePrebookData?.programs?.find((targetProgram) => targetProgram.programId === 1);
    if (!program?.orders?.length) return false;

    const currentShipDates = [];
    program.orders.forEach((order) => {
      const orderDateShip = order?.dateShip || '';
      if (orderDateShip && !currentShipDates.includes(orderDateShip)) {
        currentShipDates.push(orderDateShip);
      }
    });

    if (currentShipDates.length <= allowedShipDates) return false;

    const allowedShipDateOptions = currentShipDates.slice(0, allowedShipDates);
    const fallbackShipDate = allowedShipDateOptions[allowedShipDateOptions.length - 1] || allowedShipDateOptions[0] || '';

    if (!fallbackShipDate) return false;

    let didNormalize = false;

    program.orders.forEach((order) => {
      if (!order?.dateShip) return;

      if (!allowedShipDateOptions.includes(order.dateShip)) {
        order.dateShip = fallbackShipDate;
        didNormalize = true;
      }

      order.dateShipUI = customDateStringFormat(order.dateShip);
    });

    if (!didNormalize) return false;

    const currentDateInput = document.querySelector('.prebookCart .dateShip');
    const currentDateValue = currentDateInput?.value
      || activeOrderData?.dateShip
      || Cookies.get(SHIP_DATE_COOKIE_KEY)
      || '';

    if (currentDateInput && currentDateValue && !allowedShipDateOptions.includes(currentDateValue)) {
      currentDateInput.value = fallbackShipDate;
      currentDateInput.dispatchEvent(new Event('input', { bubbles: true }));
      currentDateInput.dispatchEvent(new Event('change', { bubbles: true }));
    }

    const normalizedShipWindow = inferShipWindowFromDate(fallbackShipDate);
    if (normalizedShipWindow) {
      activeShipWindow = normalizedShipWindow;
      Cookies.set(SHIP_WINDOW_COOKIE_KEY, normalizedShipWindow, { expires: 7 });
      updateShipWindowStateLabel(normalizedShipWindow);
    }

    Cookies.set(SHIP_DATE_COOKIE_KEY, fallbackShipDate, { expires: 7 });

    return true;
  };

  // Toggle the visible control between the native date picker and the constrained select.
  // The date input remains the canonical value that gets saved back into the order JSON.
  const syncSingleModeShipDateControls = () => {
    if (!singleMode) return;

    const dateInput = document.querySelector('.prebookCart .dateShip');
    const dateSelect = document.getElementById('shipDateSelect');

    if (!dateInput || !dateSelect) return;

    const tierState = getSingleModeTierState();
    const allowedShipDates = Number(tierState?.allowedShipDates || 0);
    const shipDateOptions = getSingleModeShipDateOptions();
    const allowedShipDateOptions = allowedShipDates > 0
      ? shipDateOptions.slice(0, allowedShipDates)
      : [];
    const savedOrderShipWindow = inferShipWindowFromDate(activeOrderData?.dateShip || '');
    const shouldPreferSavedOrderDate = !activeShipWindow || activeShipWindow === savedOrderShipWindow;
    const currentDateValue = dateInput.value
      || Cookies.get(SHIP_DATE_COOKIE_KEY)
      || (shouldPreferSavedOrderDate ? activeOrderData?.dateShip : '')
      || '';

    // Multi-date tiers should use the constrained select so the customer can only pick
    // from the ship dates already allowed by the current program tier.
    const orderPosition = getSingleModeOrderPosition();
    const shouldUseSelect = allowedShipDates > 0 && orderPosition > allowedShipDates && shipDateOptions.length > 0;

    dateSelect.innerHTML = '';

    const placeholder = document.createElement('option');
    placeholder.value = '';
    placeholder.textContent = 'Select a ship date';
    dateSelect.appendChild(placeholder);

    allowedShipDateOptions.forEach((date) => {
      const option = document.createElement('option');
      option.value = date;
      option.textContent = customDateStringFormat(date);
      dateSelect.appendChild(option);
    });

    const syncSelectToDateInput = (value) => {
      const nextValue = value || '';
      if (dateInput.value !== nextValue) {
        dateInput.value = nextValue;
        dateInput.dispatchEvent(new Event('input', { bubbles: true }));
        dateInput.dispatchEvent(new Event('change', { bubbles: true }));
      }

      updateShipWindowStateLabel(nextValue ? inferShipWindowFromDate(nextValue) : null);
    };

    if (!dateSelect.dataset.shipDateChangeBound) {
      dateSelect.addEventListener('change', (event) => {
        syncSelectToDateInput(event.target.value || '');
      });
      dateSelect.dataset.shipDateChangeBound = 'true';
    }

    if (shouldUseSelect) {
      document.querySelectorAll('.prebookCart').forEach((cartRoot) => {
        const selector = cartRoot.querySelector('#ship-window-selector');
        const datesGrid = cartRoot.querySelector('.dates-grid');
        const resetWrap = cartRoot.querySelector('.ship-window-reset-wrap');
        const form = cartRoot.closest('.cart--root')?.querySelector('.cart--form');

        if (selector) selector.style.display = 'none';
        if (datesGrid) datesGrid.style.display = 'grid';
        if (resetWrap) resetWrap.style.display = 'none';
        if (form) form.classList.remove('disabled');
      });

      dateInput.hidden = true;
      dateSelect.hidden = false;

      if (allowedShipDateOptions.length === 1) {
        dateSelect.value = allowedShipDateOptions[0];
        syncSelectToDateInput(allowedShipDateOptions[0]);
      } else if (allowedShipDateOptions.includes(currentDateValue)) {
        dateSelect.value = currentDateValue;
        syncSelectToDateInput(currentDateValue);
      } else {
        const fallbackShipDate = allowedShipDateOptions[allowedShipDateOptions.length - 1] || allowedShipDateOptions[0] || '';
        if (fallbackShipDate) {
          dateSelect.value = fallbackShipDate;
          syncSelectToDateInput(fallbackShipDate);
        } else {
          dateSelect.value = '';
        }
      }

      return;
    }

    dateSelect.hidden = true;
    dateInput.hidden = false;

    document.querySelectorAll('.prebookCart').forEach((cartRoot) => {
      const resetWrap = cartRoot.querySelector('.ship-window-reset-wrap');
      if (resetWrap) resetWrap.style.display = '';
    });

    if (currentDateValue) {
      dateInput.value = currentDateValue;
    }

    dateSelect.value = dateInput.value || '';
  };

  // Initialize Prebook preference cookie if not set
  const customerIsUsingPrebook = Cookies.get('customerUsePrebook');
  if (customerIsUsingPrebook === undefined && isRep || customerIsUsingPrebook === undefined && orderingViaPrebook) {
    Cookies.set('customerUsePrebook', false);
  }

  // Handle Prebook UI and state based on cookie
  if (customerIsUsingPrebook === 'true') {
    togglePromiseDateField(true);
    checkbox && (checkbox.checked = true);
    panelPrebookTools && panelPrebookTools.classList.remove('hide');
    // if using Prebook, hide the B2B CSV upload UI
    panelB2bCsvUpload && panelB2bCsvUpload.classList.add('hide');
    triggerB2bCsvUpload && triggerB2bCsvUpload.classList.add('hide');
    customerUsePrebook = true;
    syncCartModeUI();
    if (checkboxLabel) {
      checkboxLabel.textContent = 'Deactivate Pre-Book';
    }
    if (prebookIndicator) {
      prebookIndicator.style.display = 'inline';
    }
  } else if (customerIsUsingPrebook === 'false' || customerIsUsingPrebook === undefined) {
    togglePromiseDateField(false);
    customerUsePrebook = false;
    syncCartModeUI();
    document.querySelectorAll('.cart--form').forEach((form) => {
      form.classList.remove('disabled');
    });
    // Rep opted out of Prebook — clean related session cookies
    [
      'prebookProgram',
      'prebookProgramId',
      'prebookOrderId',
      'activePrebookProgram',
      'activePrebookProgramId',
      'activePrebookOrderId'
    ].forEach(Cookies.remove);
  }

  // Update when Rep toggles between Prebook or standard
  document.querySelector('#customerUsePrebook')?.addEventListener('change', (e) => {
    const isChecked = e.target.checked;
    togglePromiseDateField(isChecked);
    Cookies.set('customerUsePrebook', isChecked);
    forceRefresh(false);
  });

  const forceRefresh = (openCartAfterRefresh = false, redirectUrl = null) => {
    if (openCartAfterRefresh) {
      Cookies.set('openCart', 'true');
    }

    setTimeout(() => {
      if (redirectUrl) {
        window.location.href = redirectUrl; // Navigate to the provided page
      } else {
        window.location.reload(); // Refresh the current page
      }
    }, 300);
  };    

  // API Query Factory
  const runApiQuery = async (endpoint, body = {}, successCallback, errorCallback) => {
    const options = {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      redirect: 'follow',
      body: JSON.stringify(body),
    };

    try {
      console.log('🔁 API CALL:', endpoint, options);

      const response = await fetch(endpoint, options);
      const result = await response.json();

      if (!response.ok) {
        throw new Error(`Request failed with status ${response.status}`);
      }

      console.log('✅ API Success:', result);
      successCallback?.(result);
    } catch (error) {
      console.error('❌ API Error:', error);
      errorCallback?.(error);
    }
  };    

  // INITIALIZE PROGRAM - Only needed to run once
  const setCustomer = (data = null) => {
    const customerCookie = Cookies.get('customerId');

    // 1. Set activeCustomerId based on available data
    if (data?.customerId) {
      // Customer was selected by Rep
      activeCustomerId = data.customerId;
      Cookies.set('customerId', activeCustomerId);
    } else if (customerCookie && customerCookie !== 'null') {
      // Returning visit — use cookie
      activeCustomerId = customerCookie;
    } else {
      // First-time visit — use current user
      activeCustomerId = customerID;
      Cookies.set('customerId', customerID);
      Cookies.set('customerName', customerName);
    }

    // 2. UI Lock: If no customer selected yet, prompt rep to choose
    const customerIsUnselected = (
      liquidVars.prebookEnabled &&
      (customerID === customerCookie || customerCookie === undefined)
    );

    if (customerIsUnselected) {
      document.querySelectorAll('.prebookSelectCustomer').forEach(el =>
        el.classList.add('ShowSelect')
      );
    }

    // 3. Fetch and set customer data
    const endpointPath = `${prebookEndpoint}?customerId=${activeCustomerId}`;
    runApiQuery(endpointPath, false, orderSetActiveData, false);
  };    

  // INITIALIZE Custom Order - Only needed to run once
  const orderSetActiveData = (data) => {
    // Ensure metafields are present
    if (!data?.metafields) {
      console.warn('Prebook metafields are missing. Lambda may have failed to return customer data.');
      // Proceed anyway, passing undefined to buildPrebookDefaults
    }

    // Determine which metafield key to look for
    // TODO: When using Prebook as a regular customer (as opposed to a Rep), for some unknown reason the Prebook data is not writing to the prebook_customer metafield.
    // Using 'orderingViaPrebook' is allowing a regular customer to use the 'prebook_representative' metafield. This is essentially like a customer acting as their own Rep.
    //const metafieldKey = isRep ? 'prebook_representative' : 'prebook_customer';
    const metafieldKey = 'prebook_representative';
    
    // Attempt to find the relevant metafield (may be undefined — that's okay)
    const metafieldRaw = data?.metafields?.find(mf => mf.key === metafieldKey);

    // Use active customer ID as-is (expected global)
    const repCustomer = activeCustomerId;

    // Proceed to build defaults even if metafieldRaw is undefined (as per original behavior)
    buildPrebookDefaults(metafieldRaw, repCustomer);
    normalizeCompletedNonRepOrderingState();
    setPrebookUI();

    // The first header hydration can run before the metafield-backed data is ready.
    // Re-run it here so edit-mode ship-window logic sees the fully populated order data.
    updateHeaderBarState();

    // Now that the saved order data and header state are both in memory, re-run the
    // single-program tier pass so the cart rehydrates against the real projected total
    // instead of the initial empty-shell state from page load.
    if (singleMode) {
      refreshSingleModeTierState({ suppressDowngradeAlert: true }).finally(() => {
        restoreSingleModeCartState();
      });
    }
  };    
  
  // TODO: Decide which of these two functions to move forward with
  // Original version of this function with 2 programs
  // const buildPrebookDefaults = (rawData, repCustomer) => {

  //   const createDefaultProgram = (id) => ({
  //     programId: id,
  //     state: "active",
  //     orders: [],
  //     programTotal: 0,
  //     freeComboRack: false,
  //     freeGiftSku: ''
  //   });

  //   // Parse input data
  //   if (rawData?.value) {
  //     activePrebookData = JSON.parse(rawData.value);
  //   }

  //   activePrebookData = activePrebookData || {};
  //   const existingPrograms = activePrebookData.programs || [];
  //   let programs = [];

  //   // Avoid duplicating programs if already two exist
  //   if (existingPrograms.length === 2) return false;

  //   // If one program exists, add the missing one in proper order
  //   if (existingPrograms.length === 1) {
  //     const existing = existingPrograms[0];
  //     const missingId = existing.programId === 1 ? 2 : 1;
  //     programs = existing.programId === 1
  //       ? [existing, createDefaultProgram(missingId)]
  //       : [createDefaultProgram(missingId), existing];
  //   } else {
  //     // No programs exist, initialize both
  //     programs = [createDefaultProgram(1), createDefaultProgram(2)];
  //   }

  //   // Add rep ID if applicable
  //   if (isRep) {
  //     activePrebookData.representativeIds = activePrebookData.representativeIds || [];
  //     const repId = parseInt(customerID, 10);
  //     if (!activePrebookData.representativeIds.includes(repId)) {
  //       activePrebookData.representativeIds.push(repId);
  //     }
  //   }

  //   // Set customer info and program data
  //   activePrebookData.customerId = activePrebookData.customerId || parseInt(activeCustomerId, 10);
  //   activePrebookData.isFly = repCustomer.isFly;
  //   activePrebookData.programs = programs;
  // };

  // New version of this function that accounts for single vs 2 program model.
  const buildPrebookDefaults = (rawData, repCustomer) => {
    if (singleMode) {
      const createDefaultProgram = (id) => ({
        programId: id,
        state: "active",
        orders: [],
        programTotal: 0,
        freeComboRack: false,
        freeGiftSku: ''
      });

      if (rawData?.value) {
        activePrebookData = JSON.parse(rawData.value);
      }

      activePrebookData = activePrebookData || {};
      const existingPrograms = activePrebookData.programs || [];
      let programs = [];

      // Single-program mode: keep only Program 1 logic
      const existingProgram1 = existingPrograms.find(p => p.programId === 1);
      programs = [existingProgram1 || createDefaultProgram(1)];

      if (isRep) {
        activePrebookData.representativeIds = activePrebookData.representativeIds || [];
        const repId = parseInt(customerID, 10);
        if (!activePrebookData.representativeIds.includes(repId)) {
          activePrebookData.representativeIds.push(repId);
        }
      }

      activePrebookData.customerId = activePrebookData.customerId || parseInt(activeCustomerId, 10);
      activePrebookData.isFly = repCustomer.isFly;
      activePrebookData.programs = programs;

      return activePrebookData;
    } else {
      // current code stays exactly as-is
      const createDefaultProgram = (id) => ({
        programId: id,
        state: "active",
        orders: [],
        programTotal: 0,
        freeComboRack: false,
        freeGiftSku: ''
      });

      if (rawData?.value) {
        activePrebookData = JSON.parse(rawData.value);
      }

      activePrebookData = activePrebookData || {};
      const existingPrograms = activePrebookData.programs || [];
      let programs = [];

      if (existingPrograms.length === 2) return false;

      if (existingPrograms.length === 1) {
        const existing = existingPrograms[0];
        const missingId = existing.programId === 1 ? 2 : 1;
        programs = existing.programId === 1
          ? [existing, createDefaultProgram(missingId)]
          : [createDefaultProgram(missingId), existing];
      } else {
        programs = [createDefaultProgram(1), createDefaultProgram(2)];
      }

      if (isRep) {
        activePrebookData.representativeIds = activePrebookData.representativeIds || [];
        const repId = parseInt(customerID, 10);
        if (!activePrebookData.representativeIds.includes(repId)) {
          activePrebookData.representativeIds.push(repId);
        }
      }

      activePrebookData.customerId = activePrebookData.customerId || parseInt(activeCustomerId, 10);
      activePrebookData.isFly = repCustomer.isFly;
      activePrebookData.programs = programs;
    }
  };

  // Format the store program dates for the Program blocks in the UI
  const customDateStringFormat = (date) => {
    const storeProgramShipDateParts = date.split('-');

    let monthNumber = storeProgramShipDateParts[1];
    
    if( monthNumber.charAt( 0 ) === '0' ){
      monthNumber = monthNumber.slice(1);
    }

    let dayNumber = storeProgramShipDateParts[2];
    if( dayNumber.charAt( 0 ) === '0' ){
      dayNumber = dayNumber.slice(1);
    }

    return  monthNumber + '/' + dayNumber + '/' + storeProgramShipDateParts[0];
  }

  // Single-program mode keeps one program container but still needs per-ship-window bounds and UI state.
  const getShipWindowRange = (windowId) => {
    const normalizedWindowId = String(windowId) === '2' ? '2' : '1';
    const button = document.querySelector(`#ship-window-${normalizedWindowId}`);
    const buttonStart = button?.dataset.shipStart || '';
    const buttonEnd = button?.dataset.shipEnd || '';

    if (buttonStart) {
      return {
        start: buttonStart,
        end: buttonEnd
      };
    }

    const storeProgram = window[`storeProgram${normalizedWindowId}`];
    if (storeProgram?.shipStart) {
      return {
        start: storeProgram.shipStart,
        end: storeProgram.shipEnd || ''
      };
    }

    return null;
  };

  const inferShipWindowFromDate = (dateValue) => {
    if (!dateValue) return null;

    const range1 = getShipWindowRange('1');
    if (range1?.start && dateValue >= range1.start && (!range1.end || dateValue <= range1.end)) {
      return '1';
    }

    const range2 = getShipWindowRange('2');
    if (range2?.start && dateValue >= range2.start && (!range2.end || dateValue <= range2.end)) {
      return '2';
    }

    return null;
  };

  // Keep the ship-date label aligned to the selected ship window in single-program mode.
  const updateShipWindowStateLabel = (windowId) => {
    if (!singleMode) return;

    const selectedWindowId = String(windowId) === '2' ? '2' : String(windowId) === '1' ? '1' : '';
    const labelText = selectedWindowId === '2'
      ? (liquidVars.shipWindow2 || 'Ship Window 2')
      : selectedWindowId === '1'
        ? (liquidVars.shipWindow1 || 'Ship Window 1')
        : '';

    document.querySelectorAll('.prebookCart .ship-window-state').forEach((label) => {
      label.textContent = labelText ? ` (${labelText})` : '';
    });
  };

  const syncSingleModeShipWindowUI = (windowId, { persist = true, preserveDate = false, dateValue = '' } = {}) => {
    if (!singleMode) return;

    const selectedWindowId = String(windowId) === '2' ? '2' : '1';
    activeShipWindow = selectedWindowId;

    if (persist) {
      Cookies.set(SHIP_WINDOW_COOKIE_KEY, selectedWindowId, { expires: 7 });
    }

    document.querySelectorAll('#ship-window-selector .ship-window-button').forEach((button) => {
      const isSelected = button.dataset.shipWindow === selectedWindowId;
      button.classList.toggle('Selected', isSelected);
      button.setAttribute('aria-pressed', isSelected ? 'true' : 'false');
    });

    document.querySelectorAll('.prebookCart').forEach((cartRoot) => {
      const selector = cartRoot.querySelector('#ship-window-selector');
      const datesGrid = cartRoot.querySelector('.dates-grid');
      const dateInput = cartRoot.querySelector('.dateShip');

      if (selector) selector.style.display = 'none';
      if (datesGrid) datesGrid.style.display = 'grid';
      if (dateInput) {
        if (dateValue) {
          dateInput.value = dateValue;
        } else if (!preserveDate) {
          dateInput.value = '';
        }
      }
    });

    document.querySelectorAll('.cart--form').forEach((form) => {
      form.classList.remove('disabled');
    });

    if (dateValue) {
      Cookies.set(SHIP_DATE_COOKIE_KEY, dateValue, { expires: 7 });
    } else if (!preserveDate) {
      clearShipDateCookie();
    }

    cartDatesMinMax();
  };

  // Rehydrate the edit UI from the saved order without forcing the old ship-window button flow.
  // If a saved ship date already exists, the current tier should decide whether the cart shows
  // the constrained ship-date select or the native date input.
  const restoreSingleModeOrderEditState = (dateShip, { persist = true } = {}) => {
    if (!singleMode || !dateShip) return null;

    const inferredShipWindow = inferShipWindowFromDate(dateShip);
    if (!inferredShipWindow) return null;

    activeShipWindow = inferredShipWindow;

    if (persist) {
      Cookies.set(SHIP_WINDOW_COOKIE_KEY, inferredShipWindow, { expires: 7 });
      Cookies.set(SHIP_DATE_COOKIE_KEY, dateShip, { expires: 7 });
    }

    document.querySelectorAll('.prebookCart .dateShip').forEach((dateInput) => {
      dateInput.value = dateShip;
    });

    updateShipWindowStateLabel(inferredShipWindow);
    cartDatesMinMax();

    return inferredShipWindow;
  };

  const resetSingleModeShipWindowUI = ({ clearDate = true } = {}) => {
    if (!singleMode) return;

    activeShipWindow = null;
    clearShipWindowCookie();

    if (clearDate) {
      clearShipDateCookie();
    }

    document.querySelectorAll('#ship-window-selector .ship-window-button').forEach((button) => {
      button.classList.remove('Selected');
      button.setAttribute('aria-pressed', 'false');
    });

    document.querySelectorAll('.prebookCart').forEach((cartRoot) => {
      const selector = cartRoot.querySelector('#ship-window-selector');
      const datesGrid = cartRoot.querySelector('.dates-grid');
      const resetWrap = cartRoot.querySelector('.ship-window-reset-wrap');
      const dateInput = cartRoot.querySelector('.dateShip');

      if (selector) selector.style.display = '';
      if (datesGrid) datesGrid.style.display = 'none';
      if (resetWrap) resetWrap.style.display = '';
      if (dateInput && clearDate) {
        dateInput.value = '';
        dateInput.removeAttribute('min');
        dateInput.removeAttribute('max');
      }
    });

    if (customerUsePrebook) {
      document.querySelectorAll('.cart--form').forEach((form) => {
        form.classList.add('disabled');
      });
    }

    cartDatesMinMax();
  };

  // Re-apply the single-program cart state after an AJAX cart refresh or on initial load.
  // This keeps the cart form disabled until a ship window is selected, then restores the
  // selected window/date state whenever the cart drawer is re-rendered.
  const restoreSingleModeCartState = () => {
    if (!singleMode || !isPrebookSessionActive()) return;

    const savedProgram = activePrebookData?.programs?.find((program) => program.programId === 1);
    const activeOrderIndex = Math.max(0, getSingleModeOrderPosition() - 1);
    const savedOrderFromProgram = savedProgram?.orders?.[activeOrderIndex] || null;
    const savedShipDate = Cookies.get(SHIP_DATE_COOKIE_KEY)
      || activeOrderData?.dateShip
      || savedOrderFromProgram?.dateShip
      || '';
    const savedShipWindow = savedShipDate ? inferShipWindowFromDate(savedShipDate) : null;
    const selectedShipWindow = savedShipWindow
      || activeShipWindow
      || Cookies.get(SHIP_WINDOW_COOKIE_KEY);

    // Once a ship date is known, keep the edit cart on the tier-aware ship-date controls
    // instead of reopening the ship-window button picker.
    if (savedShipDate) {
      if (savedShipWindow) {
        activeShipWindow = savedShipWindow;
      }

      syncSingleModeShipDateControls();
      return;
    }

    if (selectedShipWindow) {
      syncSingleModeShipWindowUI(selectedShipWindow, {
        persist: false,
        preserveDate: true,
        dateValue: savedShipDate
      });
      return;
    }

    resetSingleModeShipWindowUI({ clearDate: false });
  };
  
  // This function is responsible for building each Program object as is needed for injection into the UI.
  // This includes building a fresh Program where all data and content is at the default starting point. The guts of the function itself is able to determine this.
  const setPrebookUI = (
    rebuildFromCSV = false,
  ) => {
    if (!liquidVars.prebookEnabled) return;

    const items = [];

    const formatCurrency = cents => new Intl.NumberFormat('en-US', {
      style: 'currency',
      currency: 'USD'
    }).format(Number(cents) / 100);

    // Legacy for 2 Program model
    const getThresholdData = programId => {
      const isProgram2 = programId == 2;
      return {
        firstThreshold: Number(isProgram2 ? program2FirstDiscount : program1FirstDiscount),
        secondThreshold: Number(isProgram2 ? program2SecondDiscount : program1SecondDiscount),
        firstDiscountPercent: isProgram2 ? program2FirstDiscountPercentage : program1FirstDiscountPercentage,
        secondDiscountPercent: isProgram2 ? program2SecondDiscountPercentage : program1SecondDiscountPercentage,
      };
    };

    // New Single Program mode
    // Get the thresholds applicable to all orders regardless of their Ship Window assignments
    // Get the discount percentages applicable to the Ship Windows that each order will belong to
    const getThresholdDataSingleProgramMode = () => {
      return {
        firstThreshold: Number(program1FirstDiscount),
        secondThreshold: Number(program1SecondDiscount),
        shipWindow1FirstDiscountPercent: program1FirstDiscountPercentage,
        shipWindow1SecondDiscountPercent: program1SecondDiscountPercentage,
        shipWindow2FirstDiscountPercent: program2FirstDiscountPercentage,
        shipWindow2SecondDiscountPercent: program2SecondDiscountPercentage
      }
    }

    // Preview-only discount breakdown for single_program mode.
    // This mirrors the submit-time VII/Combo bonus rules so the UI can describe the
    // same discount the program is actually qualifying for, without mutating state here.
    const getSingleModeDiscountPreview = (targetProgram, threshold, storeProgramConfig) => {
      const grossTotal = (targetProgram?.orders || []).reduce((total, order) => {
        return total + Number(order.orderTotal || 0);
      }, 0);

      const incentiveData = {
        viiUnits: 0,
        comboUnits: 0
      };

      (targetProgram?.orders || []).forEach(order => {
        (order.items || []).forEach(item => {
          const itemQty = Number(item.quantity || 0);
          const vendor = String(item.vendor || '').trim().toUpperCase();
          const productType = String(item.productType || item.product_type || '').trim();

          if (vendor === 'SEVIIN REELS') {
            incentiveData.viiUnits += itemQty;
          }

          if (['Fishing System', 'Fishing Systems'].includes(productType)) {
            incentiveData.comboUnits += itemQty;
          }
        });
      });

      const hasSeviinReel = (targetProgram?.orders || []).some(order =>
        (order.items || []).some(item =>
          String(item.vendor || '').trim().toUpperCase() === 'SEVIIN REELS'
        )
      );

      const firstThreshold = Number(threshold?.firstThreshold || 0);
      const secondThreshold = Number(threshold?.secondThreshold || 0);
      const firstDiscountPercent = Number(threshold?.shipWindow1FirstDiscountPercent || 0);
      const secondDiscountPercent = Number(threshold?.shipWindow1SecondDiscountPercent || 0);
      const orderTotalMin = Number(storeProgramConfig?.orderTotalMin || 0);

      // Base discount mirrors the normal threshold logic, but it is calculated from the
      // raw order totals so the preview can show the same value that will be saved later.
      let baseDiscountPercent = 0;
      if (hasSeviinReel || grossTotal >= orderTotalMin) {
        if (grossTotal >= secondThreshold) {
          baseDiscountPercent = secondDiscountPercent;
        } else if (grossTotal >= firstThreshold) {
          baseDiscountPercent = firstDiscountPercent;
        }
      }

      // The VII / Combo incentive is a bonus layer that stacks on top of the base discount.
      const hasBothMins = incentiveData.viiUnits >= 12 && incentiveData.comboUnits >= 12;
      const hasEitherMin = incentiveData.viiUnits >= 12 || incentiveData.comboUnits >= 12;
      let bonusDiscountPercent = 0;
      let freeComboRack = false;

      if (grossTotal >= firstThreshold) {
        if (grossTotal >= secondThreshold) {
          if (hasBothMins) {
            bonusDiscountPercent = 7;
            freeComboRack = true;
          } else if (hasEitherMin) {
            bonusDiscountPercent = 3;
            freeComboRack = true;
          }
        } else {
          if (hasBothMins) {
            bonusDiscountPercent = 5;
            freeComboRack = true;
          } else if (hasEitherMin) {
            bonusDiscountPercent = 2;
            freeComboRack = true;
          }
        }
      }

      return {
        baseDiscountPercent,
        bonusDiscountPercent,
        totalDiscountPercent: baseDiscountPercent + bonusDiscountPercent,
        freeComboRack
      };
    };

    const buildProgram = (program) => {
      // If we're in single program mode guard against ever having program 2 slip through
      if (singleMode && program.programId !== 1) return null;

      const storeProgram = window[`storeProgram${program.programId}`];
      const storeProgram2 = window[`storeProgram2`];
      
      const activeOrderId = parseInt(Cookies.get('prebookOrderId') || '0', 10);

      const programSize = program.orders.length;
      const classes = programSize >= storeProgram.orderCountMax ? 'red' : '';
      const percentageReached = ~~((program.programTotal * 100) / storeProgram.orderTotalMin);
      const threshold = singleMode ? getThresholdDataSingleProgramMode() : getThresholdData(program.programId);

      const [formattedAmount1, formattedAmount2] = [
        formatCurrency(threshold.firstThreshold),
        formatCurrency(threshold.secondThreshold)
      ];

      // Add custom date + money formatting to orders
      program.orders.forEach(order => {
        order.dateShipUI = customDateStringFormat(order.dateShip);
        order.totalFormat = theme.utils.formatMoney(order.orderTotal);
      });

      // Determine ordering eligibility
      let allowAnotherOrder = true;
      let programValidToProcess = true;
      let orderInvalidText = `If your program has only one order, its total can’t exceed ${formattedAmount1}.<br>Please reduce the amount for Order 1 to continue.`

      let startOrderTT = liquidVars.toolTipStartOrder;
      let csvOrderTT = liquidVars.toolTipCSV;

      // if (programSize === 1) {
      // } else if (programSize === 2) {
      //   if (program.programTotal < threshold.firstThreshold) {
      //     allowAnotherOrder = true;
      //     programValidToProcess = false;
      //     orderInvalidText = `This program total isn’t quite high enough for two orders yet.<br>You can increase the program total to at least ${formattedAmount1} or remove an order to continue.`
      //   }
      // } else if (programSize >= 3) {
      //   allowAnotherOrder = false;
      //   if(program.programTotal < threshold.secondThreshold){
      //     programValidToProcess = false;
      //     orderInvalidText = `This program total isn’t quite high enough for three orders yet.<br>You can increase the program total to at least ${formattedAmount2} or remove an order to continue.`
      //   }
      // }

      // Discount message
      // TODO: Currently the threshold discount percentages offered for program 1/ship window 1 and program 2/ship window 2 are the same.
      // Because of this we are simply pulling values from shipWindow 1 when in singleMode.
      // We may want to update this to allow more accurate messaging for if/when ship window 1 and ship window 2 orders have different threshold percentage discounts
      let discountMessage = liquidVars.discountActivated;
      if (singleMode) {
        // In single_program mode the preview message needs to show the stacked base discount
        // plus the VII / Combo bonus layer, because that is the actual discount flow being saved.
        const discountPreview = getSingleModeDiscountPreview(program, threshold, storeProgram);

        if (discountPreview.totalDiscountPercent > 0) {
          if (discountPreview.baseDiscountPercent > 0 && discountPreview.bonusDiscountPercent > 0) {
            discountMessage = `Your program qualifies for ${discountPreview.baseDiscountPercent}% base discount + ${discountPreview.bonusDiscountPercent}% VII/Combo bonus = ${discountPreview.totalDiscountPercent}% off.`;
          } else if (discountPreview.baseDiscountPercent > 0) {
            discountMessage = `Your program qualifies for ${discountPreview.baseDiscountPercent}% off. Discount will be applied to each order upon submission.`;
          } else if (discountPreview.bonusDiscountPercent > 0) {
            discountMessage = `Your program qualifies for ${discountPreview.bonusDiscountPercent}% VII/Combo bonus = ${discountPreview.totalDiscountPercent}% off.`;
          }
        }
      } else if (program.programTotal >= threshold.secondThreshold) {
        discountMessage = `Your program qualifies for ${threshold.secondDiscountPercent}% off. Discount will be applied to each order upon submission.`;
      } else if (program.programTotal >= threshold.firstThreshold) {
        discountMessage = `Your program qualifies for ${threshold.firstDiscountPercent}% off. Discount will be applied to each order upon submission.`;
      }

      return {
        allowNextOrder: allowAnotherOrder,
        textProgramTitle: liquidVars.ProgramTitle,
        textReached: liquidVars.minimumReached,
        textHeading: program.programId === 1 ? liquidVars.prebookOneHeading : liquidVars.prebookTwoHeading,
        textShipBetween: liquidVars.shipBetween,
        textShipBefore: liquidVars.shipBefore,
        textShipWindow1: liquidVars.shipWindow1,
        textShipWindow2: liquidVars.shipWindow2,
        textShipWindow1Before: liquidVars.shipWindow1Before,
        textShipWindow2Before: liquidVars.shipWindow2Before,
        textOrdersRemaining: liquidVars.ordersRemaining,
        textStartOrder: liquidVars.startOrder,
        textNoOrders: liquidVars.noOrders,
        textDeleteSavedOrder: liquidVars.deleteSavedOrder,
        textDeleteAddress: liquidVars.deleteAddress,
        textCancelAddress: liquidVars.cancelAddress,
        textOrder: liquidVars.order,
        textPrebookShip: liquidVars.prebookShip,
        textPrebookCancel: liquidVars.prebookCancel,
        textPrebookEditOrder: liquidVars.prebookEditOrder,
        textDiscountActivated: discountMessage,
        textAwayFromDiscount: liquidVars.awayFromPrebook,
        textSubmitDisclaimer: liquidVars.submitDisclaimer,
        textPrebookSubmit: liquidVars.prebookSubmit,
        textPrebookOrderSubmitted: liquidVars.orderSubmitted,
        textPrebookConfirmSubmit: liquidVars.prebookConfirmSubmit,
        textPrebookExit: liquidVars.prebookExit,
        textPrebookState: liquidVars.prebookState,
        shipStart: customDateStringFormat(storeProgram.shipStart),
        shipEnd: customDateStringFormat(storeProgram.shipEnd),
        singleProgramMode: singleMode,
        shipStart2: customDateStringFormat(storeProgram2.shipStart),
        shipEnd2: customDateStringFormat(storeProgram2.shipEnd),
        id: program.programId,
        classesProgress: `status-bar program-progress-${program.programId}`,
        progressBarClasses: `pb-progress-bar program-progress-${program.programId}`,
        progressId: `programProgress${program.programId}`,
        barID: `programOrders${program.programId}`,
        amountAwayClass: `amountAway${program.programId}`,
        textCartProgressClass: `cartProgress${program.programId}`,
        program,
        hasOrders: programSize > 0,
        orderSize: programSize,
        maxOrders: storeProgram.orderCountMax,
        storeProgram,
        storeProgram2,
        ordersRemaining: storeProgram.orderCountMax - programSize,
        percentageReached,
        activeOrderId: activeOrderId + 1,
        minReached: percentageReached >= 100,
        reachedFull: percentageReached >= 100,
        minTotal: storeProgram.orderCountMax - programSize,
        amountAway: theme.utils.formatMoney(
          storeProgram.orderTotalMin - (program.programTotal || 0)
        ),
        programState: program.state,
        isComplete: ['complete', 'ordered'].includes(program.state),
        maxReached: programSize >= storeProgram.orderCountMax,
        max: storeProgram.orderCountMax,
        diff: storeProgram.orderCountMax - programSize,
        total: program.programTotal || null,
        // totalOverMin: program.programTotal > program1OrderTotalMin,
        totalOverMin: program.programTotal >= storeProgram.orderTotalMin,
        activeProgramNumber: String(program.programId),
        classes,
        activateToolTips: liquidVars.activatePrebookToolTips,
        toolTipStartOrder: startOrderTT,
        toolTipCSV: csvOrderTT,
        toolTipDetails: liquidVars.toolTipDetails,
        programValidToProcess,
        orderInvalidText,
        programSubmitDisclaimer: liquidVars.programSubmitDisclaimer,
        programTotal: theme.utils.formatMoney(program.programTotal)
      };
    };

    activePrebookData.programs.forEach(program => {
      // If we're in single program mode guard against ever having program 2 slip through
      if (singleMode && program.programId !== 1) return;
      const currentProgramTurnedOnInThemeSettings = window[`program${program.programId}Enabled`];
      if (currentProgramTurnedOnInThemeSettings && program.orders) {
        items.push(buildProgram(program));
      }
    });

    const render = (selector, templateId, context) => {
      const templateEl = document.querySelector(templateId);
      const targetEl = document.querySelector(selector);

      if (!templateEl) {
        console.warn(`Template element not found for selector: '${templateId}'`);
        return;
      }

      if (!targetEl) {
        console.warn(`Target element not found for selector: '${selector}'`);
        return;
      }

      const compiled = Handlebars.compile(templateEl.innerHTML);
      targetEl.innerHTML = compiled(context);
    };

    // If the customer is uploading a CSV we need to re-render the Header Bar but not the programs on the page.
    // The Programs get re-rendered after the CSV is done processing and the user closes the CSV upload modal.
    rebuildFromCSV ?  updateHeaderBarState() : render('#program-handlebar-template', '#program-template', { items });

    render('.cartProgramProgress', '#prebook-cart-progress', { items });
    render('#prebook-header-wrapper', '#prebook-bar-template', { items });

    document.querySelectorAll('.saveOrder').forEach(el => el.classList.remove('processing'));
    document.querySelectorAll('.prebookSelectCustomer').forEach(el => el.classList.remove('Show'));
  };

  const setCartUI = () => {
    const shouldShowSuccessUI = !liquidVars.prebookEnabled || (!customerUsePrebook && isRep);

    if (shouldShowSuccessUI) {
      document.querySelectorAll('.submitOrder').forEach(el => el.classList.remove('processing'));
      orderSubmitSuccessUI();
    }
  };

  const orderSubmitSuccessUI = () => {
    // Hide elements
    document.querySelectorAll('.prebookCart, .cart--form').forEach(el => {
      el.style.display = 'none';
    });

    // Inject success message after cart header
    const cartHeader = document.querySelector('.cart--header');
    if (cartHeader) {
      const successDiv = document.createElement('div');
      successDiv.className = 'orderCartSuccess';
      successDiv.textContent = liquidVars.cartSuccess;
      cartHeader.insertAdjacentElement('afterend', successDiv);
    }

    // Clear cart after delay
    setTimeout(() => {
      Utilities.clearCart();
    }, 3000);
  };    
  
  // ----- DISCOUNTS ----- 
  const applyPrebookDiscounts = (program, isFly) => {
    const getDiscountConfig = (programId) => {
      const isProgram2 = programId === 2;
      return {
        orderTotalMin: isProgram2 ? program2OrderTotalMin : program1OrderTotalMin,
        firstThreshold: isProgram2 ? program2FirstDiscount : program1FirstDiscount,
        secondThreshold: isProgram2 ? program2SecondDiscount : program1SecondDiscount,
        firstDiscountPercent: isProgram2 ? program2FirstDiscountPercentage : program1FirstDiscountPercentage,
        secondDiscountPercent: isProgram2 ? program2SecondDiscountPercentage : program1SecondDiscountPercentage,
      };
    };

    const getGrossProgramTotal = (targetProgram) => {
      return (targetProgram.orders || []).reduce((total, order) => {
        return total + Number(order.orderTotal || 0);
      }, 0);
    };

    const getProgramIncentiveData = (targetProgram) => {
      const incentiveData = {
        viiUnits: 0,
        comboUnits: 0,
      };

      (targetProgram.orders || []).forEach(order => {
        (order.items || []).forEach(item => {
          const itemQty = Number(item.quantity || 0);
          const vendor = String(item.vendor || '').trim().toUpperCase();
          const productType = String(item.productType || item.product_type || '').trim();

          if (vendor === 'SEVIIN REELS') {
            incentiveData.viiUnits += itemQty;
          }

          if (['Fishing System', 'Fishing Systems'].includes(productType)) {
            incentiveData.comboUnits += itemQty;
          }
        });
      });

      return {
        ...incentiveData,
        hasViiMin: incentiveData.viiUnits >= 12,
        hasComboMin: incentiveData.comboUnits >= 12,
      };
    };

    const resolveBaseDiscountPercent = ({
      grossTotal,
      orderTotalMin,
      firstThreshold,
      secondThreshold,
      firstDiscountPercent,
      secondDiscountPercent,
    }) => {
      const hasSeviinReel = (program.orders || []).some(order =>
        (order.items || []).some(item =>
          String(item.vendor || '').trim().toUpperCase() === 'SEVIIN REELS'
        )
      );

      if (!(hasSeviinReel || grossTotal >= orderTotalMin)) {
        return 0;
      }

      if (grossTotal >= secondThreshold) {
        return Number(secondDiscountPercent) || 0;
      }

      if (grossTotal >= firstThreshold) {
        return Number(firstDiscountPercent) || 0;
      }

      return 0;
    };

    const resolveBonusDiscount = ({
      grossTotal,
      firstThreshold,
      secondThreshold,
      incentiveData,
    }) => {
      if (grossTotal < firstThreshold) {
        return {
          bonusDiscountPercent: 0,
          freeComboRack: false
        };
      }

      const hasBothMins = incentiveData.hasViiMin && incentiveData.hasComboMin;
      const hasEitherMin = incentiveData.hasViiMin || incentiveData.hasComboMin;

      if (grossTotal >= secondThreshold) {
        if (hasBothMins) {
          return {
            bonusDiscountPercent: 7,
            freeComboRack: true
          };
        }

        if (hasEitherMin) {
          return {
            bonusDiscountPercent: 3,
            freeComboRack: true
          };
        }
      } else {
        if (hasBothMins) {
          return {
            bonusDiscountPercent: 5,
            freeComboRack: true
          };
        }

        if (hasEitherMin) {
          return {
            bonusDiscountPercent: 2,
            freeComboRack: true
          };
        }
      }

      return {
        bonusDiscountPercent: 0,
        freeComboRack: false
      };
    };

    const applyDiscountResult = (targetProgram, grossTotal, totalDiscountPercent, freeComboRack) => {
      const finalTotal = Math.max(0, Math.round(grossTotal - (grossTotal * (totalDiscountPercent / 100))));
      const freeGiftSku = freeComboRack ? String(liquidVars.freeGiftProduct || '').trim() : '';

      targetProgram.programTotal = finalTotal;
      targetProgram.freeComboRack = freeComboRack;
      targetProgram.freeGiftSku = freeGiftSku;

      (targetProgram.orders || []).forEach(order => {
        if (totalDiscountPercent > 0) {
          order.discountAmount = totalDiscountPercent.toString();
        } else {
          delete order.discountAmount;
        }
      });
    };

    const {
      orderTotalMin,
      firstThreshold,
      secondThreshold,
      firstDiscountPercent,
      secondDiscountPercent
    } = getDiscountConfig(program.programId);

    const grossTotal = getGrossProgramTotal(program);
    const incentiveData = getProgramIncentiveData(program);

    let baseDiscountPercent = 0;
    let bonusDiscountPercent = 0;
    let freeComboRack = false;

    if (isFly) {
      if (grossTotal >= 750000) {
        baseDiscountPercent = 20;
      } else if (grossTotal >= 500000) {
        baseDiscountPercent = 15;
      } else if (grossTotal >= 250000) {
        baseDiscountPercent = 5;
      }
    } else {
      baseDiscountPercent = resolveBaseDiscountPercent({
        grossTotal,
        orderTotalMin,
        firstThreshold,
        secondThreshold,
        firstDiscountPercent,
        secondDiscountPercent,
      });

      const bonusDiscount = resolveBonusDiscount({
        grossTotal,
        firstThreshold,
        secondThreshold,
        incentiveData,
      });

      bonusDiscountPercent = bonusDiscount.bonusDiscountPercent;
      freeComboRack = bonusDiscount.freeComboRack;
    }

    const totalDiscountPercent = baseDiscountPercent + bonusDiscountPercent;

    applyDiscountResult(program, grossTotal, totalDiscountPercent, freeComboRack);

    return program;
  };

  const applyFishingSystemDiscount = (program) => {
    if (!program.orders?.length) return false;

    const FISHING_SYSTEM_MIN_QTY = 15;
    const UNIQUE_SKU_MIN = 4;

    const systemSkuIds = new Set();
    const nonSystemSkuIds = new Set();
    let systemProductsQty = 0;

    // Process all items in all orders
    program.orders.forEach(order => {
      order.items.forEach(item => {
        const isSystem = item.isFishingSystem === 'true';
        const itemQty = Number(item.quantity);

        if (isSystem) {
          systemSkuIds.add(item.id);
          systemProductsQty += itemQty;
        } else {
          nonSystemSkuIds.add(item.id);
        }
      });
    });

    const hasEnoughSystemQty = systemProductsQty >= FISHING_SYSTEM_MIN_QTY;
    const hasEnoughUniqueSkus = systemSkuIds.size >= UNIQUE_SKU_MIN;
    const hasNonSystemProducts = nonSystemSkuIds.size > 0;

    // Check discount eligibility
    if (hasNonSystemProducts && hasEnoughSystemQty && hasEnoughUniqueSkus) {
      program.nonFishingSystemSKUs = Array.from(nonSystemSkuIds);

      program.orders.forEach(order => {
        order.items.forEach(item => {
          if (nonSystemSkuIds.has(item.id)) {
            const price = Number(item.price);
            item.price = Math.round(price * 0.96).toString(); // 4% discount
          }
        });
      });
    }

    return program;
  };    

  // ----- PROGRAM/ORDER UPDATING ----- 
  const orderSave = async (programId, orderId, dateShip, note, po) => {
    if (isCompletedNonRepPrebook()) return false;

    const programIndex = activePrebookData.programs?.findIndex(
      p => p.programId === parseInt(programId)
    ) ?? 0;

    const dateInput = getActiveCartDateInput();
    if (!dateInput || !dateInput.value) {
      alert('Select a ship date to continue');
      return false;
    }

    document.querySelectorAll('.saveOrder').forEach(el =>
      el.classList.add('processing')
    );

    try {
      const cart = await fetch('/cart.js').then(res => res.json());

      const itemsToSubmit = cart.items.map(item => ({
        id: item.id,
        quantity: item.quantity,
        sku: item.sku,
        vendor: item.vendor,
        isFishingSystem: item.product_type === 'Fishing System',
        productType: item.product_type || '',
        price: item.price,
        title: item.product_title || item.title
      }));

      // ✅ Pull CSV data for this specific Program + Order
      const csvCookieKey = `prebookPendingCSV_${programId}_${orderId}`;
      let csvData = {};
      try {
        csvData = JSON.parse(Cookies.get(csvCookieKey) || "{}");
      } catch (e) {
        console.warn("No CSV cookie found or parse failed", e);
      }

      // TODO: itemsNoQty code can be uncommented if you want to display insufficient quantity items in the CSV upload feedback modal. Look for other instances to uncomment including within theme.liquid.
      const orderToSave = {
        note,
        poNumber: po,
        dateShip,
        orderTotal: cart.total_price,
        items: itemsToSubmit,
        itemsNotFound: csvData.itemsNotFound || [],
        itemsDraft: csvData.itemsDraft || []
        //itemsNoQty: csvData.itemsNoQty || []
      };

      const program = activePrebookData.programs[programIndex];
      program.orders[orderId] = orderToSave;

      // ✅ Clear this cookie after saving
      Cookies.remove(csvCookieKey);

      program.programTotal = program.orders.reduce(
        (total, order) => total + order.orderTotal,
        0
      );

      if (!Array.isArray(activePrebookData.representativeIds)) {
        activePrebookData.representativeIds = [];
      }
      if (!activePrebookData.representativeIds.includes(customerID)) {
        activePrebookData.representativeIds.push(customerID);
      }

      // ✅ Wait for cart to fully clear before updating the UI
      await Utilities.clearCart(false);
      latestCartTotal = 0;
      // Reset the cached tier silently here because this is an intentional clear/rebuild
      // flow, not a customer-driven downgrade.
      await refreshSingleModeTierState({ suppressDowngradeAlert: true });
      if (singleMode) {
        resetSingleModeShipWindowUI({ clearDate: true });
      }

      const submitPayload = JSON.parse(JSON.stringify(activePrebookData || {}));
      submitPayload.isPrebookOrder = true;
      
      // ✅ Update UI immediately after cart clears
      await runApiQuery(prebookEndpoint, submitPayload, () => setPrebookUI(), false);

      if (liquidVars.redirectOnSave && liquidVars.redirectOnSavePage) {
        forceRefresh(false, `/pages/${liquidVars.redirectOnSavePage}`);
      }        


    } catch (error) {
      console.error('Error saving order:', error);
      alert('There was an error saving your order. Please try again.');
    }
  };    

  // Function for Reps to submit non-prebook orders to the API
  const repOrderSubmit = async (programId, orderId, dateShip, note, po) => {
    if (!isRep) return false;

    document.querySelectorAll('.submitOrder').forEach(el =>
      el.classList.add('processing')
    );

    try {
      const cart = await fetch('/cart.js').then(res => res.json());

      const itemsToSubmit = cart.items.map(item => ({
        id: item.id,
        quantity: item.quantity,
        sku: item.sku,
        vendor: item.vendor,
        isFishingSystem: item.product_type === 'Fishing System',
        productType: item.product_type || '',
        price: item.price,
        title: item.product_title || item.title
      }));

      const orderTotal = cart.total_price;

      // ✅ Pull CSV data for this specific Program + Order
      const csvCookieKey = `prebookPendingCSV_${programId}_${orderId}`;
      let csvData = {};
      try {
        csvData = JSON.parse(Cookies.get(csvCookieKey) || "{}");
      } catch (e) {
        console.warn("No CSV cookie found or parse failed", e);
      }

      // TODO: itemsNoQty code can be uncommented if you want to display insufficient quantity items in the CSV upload feedback modal. Look for other instances to uncomment including within theme.liquid.
      const orderToSubmit = {
        note,
        poNumber: po,
        dateShip,
        dateShipUI: customDateStringFormat(dateShip),
        orderTotal,
        items: itemsToSubmit,
        totalFormat: theme.utils.formatMoney(orderTotal),
        itemsNotFound: csvData.itemsNotFound || [],
        itemsDraft: csvData.itemsDraft || []
        //itemsNoQty: csvData.itemsNoQty || []
      };

      const program = activePrebookData.programs[programId];
      program.orders[orderId] = orderToSubmit;
      program.programTotal = orderTotal;
      program.state = 'complete';

      // ✅ Clear this cookie after submitting
      Cookies.remove(csvCookieKey);

      if (activePrebookData.programs[1]) {
        activePrebookData.programs[1].state = 'active';
      }

      if (isRep) {
        const repIds = activePrebookData.representativeIds || [];
        if (!repIds.includes(customerID)) {
          repIds.push(customerID);
        }
        activePrebookData.representativeIds = repIds;
      }

      // Standard rep orders should not inherit any of the Prebook discount stack.
      // Build a request-only payload so Lambda can distinguish this as a non-prebook
      // submission without mutating the live in-memory prebook state.
      const submitPayload = JSON.parse(JSON.stringify(activePrebookData || {}));
      submitPayload.isPrebookOrder = false;

      await Utilities.clearCart(false);
      latestCartTotal = 0;
      // Reset the cached tier silently here because this is an intentional clear/rebuild
      // flow, not a customer-driven downgrade.
      await refreshSingleModeTierState({ suppressDowngradeAlert: true });
      if (singleMode) {
        resetSingleModeShipWindowUI({ clearDate: true });
      }
      await runApiQuery(prebookEndpoint, submitPayload, setCartUI, false);

    } catch (error) {
      console.error('❌ Failed to submit rep order:', error);
      alert('There was an error submitting the order. Please try again.');
    }
  };    
  
  const prebookProgramOrderEdit = async (programId, orderId) => {
    // Set program/order context in cookies
    // Wait for the order context and ship-window state to finish restoring before the cart is rebuilt.
    const normalizedOrderId = Number.parseInt(orderId, 10) || 0;
    const editProgram = activePrebookData.programs?.find(p => p.programId == programId);
    const editOrder = editProgram?.orders?.[normalizedOrderId] || null;

    // Seed the edit slot before the cart is rebuilt so single-program tier logic can
    // resolve the correct order position while the edit flow rehydrates.
    if (singleMode) {
      activeOrder = normalizedOrderId;
      activeOrderData = editOrder;
    }

    await setActiveProgram(programId, normalizedOrderId, false, true);

    if (singleMode) {
      if (editOrder?.dateShip) {
        restoreSingleModeOrderEditState(editOrder.dateShip);
      }
    }

    try {
      // ✅ Wait for cart to fully clear before re-adding items
      await Utilities.clearCart(false);

      document.getElementById('order-loading-screen').style.display = 'flex';

      // Reload cart with selected program order's items
      const thisProgram = activePrebookData.programs.find(p => p.programId == programId);
      const orderItems = thisProgram?.orders?.[normalizedOrderId]?.items;

      if (orderItems && Array.isArray(orderItems)) {
        // Rebuild the edited order with the batched cart-add helper so large orders
        // do not hit the slower one-by-one add path.
        const productQueue = orderItems.map((item) => ({
          id: item.id,
          quantity: item.quantity,
        }));

        await Utilities.addProductsToCartBatched(
          productQueue,
          () => {
            window.location.reload();
          },
          (errorMessage, failedBatch) => {
            console.warn(
              '⚠️ Failed edit-order batch:',
              failedBatch,
              'Reason:',
              errorMessage
            );
            alert('Unable to load order for editing. Please try again.');
          },
          20
        );
      } else {
        console.warn(`No items found for Program ${programId}, Order ${normalizedOrderId}`);
      }

    } catch (error) {
      console.error('Error clearing cart or loading order items:', error);
      alert('Unable to load order for editing. Please try again.');
    }
  };    

  const prebookProgramOrderDelete = async (programId, orderId) => {
    const program = activePrebookData.programs.find(p => p.programId == programId);

    if (!program || !Array.isArray(program.orders)) {
      console.warn(`Program ${programId} not found or orders list is invalid.`);
      return;
    }

    if (orderId < 0 || orderId >= program.orders.length) {
      console.warn(`Order ID ${orderId} is out of bounds for Program ${programId}.`);
      return;
    }

    // Remove the order and refresh the UI
    program.orders.splice(orderId, 1);

    // Recalculate what the new Program Total is after removal of order
    const allProgramOrders = activePrebookData.programs[programId - 1].orders;
    const totalProgramValue = allProgramOrders.reduce((sum, order) => {
      return sum + (order.orderTotal || 0);
    }, 0);
    activePrebookData.programs[programId - 1].programTotal = totalProgramValue;
    await Utilities.clearCart(false);
    latestCartTotal = 0;
    const submitPayload = JSON.parse(JSON.stringify(activePrebookData || {}));
    submitPayload.isPrebookOrder = true;
    await runApiQuery(prebookEndpoint, submitPayload, () => setPrebookUI(), false);      
  };

  const prebookProgramSubmit = (programId) => {
    if (!programId) return false;

    // Disable the submit button and show status
    const submitBtn = document.querySelector(`#submitOrder${programId}`);
    if (submitBtn) {
      submitBtn.textContent = 'Submitting order…';
      submitBtn.disabled = true;
    }

    let program = activePrebookData.programs.find(p => p.programId == programId);
    if (!program) {
      console.warn(`Program with ID ${programId} not found.`);
      if (submitBtn) {
        submitBtn.textContent = 'Submit Order';
        submitBtn.disabled = false;
      }
      return false;
    }

    // Apply any eligible discounts
    program = applyFishingSystemDiscount(program);
    program = applyPrebookDiscounts(program, activePrebookData.isFly);

    // Reassign updated program to the global data
    const index = activePrebookData.programs.findIndex(p => p.programId == programId);
    if (index !== -1) {
      activePrebookData.programs[index] = program;
    }

    const submitPayload = JSON.parse(JSON.stringify(activePrebookData || {}));
    submitPayload.isPrebookOrder = true;

    // Submit the data
    runApiQuery(prebookEndpoint, submitPayload, () => setPrebookUI(), () => {
      // Optional error callback fallback UI reset
      if (submitBtn) {
        submitBtn.textContent = 'Submit Order';
        submitBtn.disabled = false;
      }
      alert('Submit failed. Please try again.');
    });
  };    

  // The Lambda is responsible for returning each customer object in the Reps customer list metafield.
  // Liquid cannot access customer data (except for the customer currently logged in)
  const getRepMetafields = () => {
    if (!customerID) {
      console.warn('Missing customer ID for metafields request.');
      return;
    }

    const endpointPath = `${prebookEndpoint}?customerId=${customerID}`;
    runApiQuery(endpointPath, null, setRepCustomerListUI, false);
  };    

  const setRepCustomerListUI = (data) => {
    const customerListArray = data?.referencedCustomers;
    const container = document.querySelector('.rep-drop-select');

    if (!container) {
      console.warn('Rep customer select container not found.');
      return;
    }

    // Clear existing list
    container.innerHTML = '';

    if (Array.isArray(customerListArray) && customerListArray.length > 0) {
      const fragment = document.createDocumentFragment();

      customerListArray.forEach(({ id, first_name, last_name }) => {
        const btn = document.createElement('button');
        btn.setAttribute('data-value', id);
        btn.textContent = `${first_name} ${last_name}`;
        if (id == activeCustomerId) btn.classList.add('Selected');
        fragment.appendChild(btn);
      });

      container.appendChild(fragment);
    }
  };

  // INITIALIZE
  setCustomer();

  // Get the Reps metafields. Specifically for building the customer list UI
  getRepMetafields();

  // Note: activeOrder and activeOrderData are different. 
  // 'activeOrder' will eventually contain the current order number cookie. 
  // 'activeOrderData' will eventually store the entire contents of the active object.
  const $prebookBar = $(document.getElementById('prebookBar'));
  const $prebookPopup = $(document.getElementById('prebookPopup'));

  let activeProgram = null;
  let activeOrder = null;
  let activeOrderData = null;
  let activeShipWindow = Cookies.get(SHIP_WINDOW_COOKIE_KEY) || null;
  let programMax;

  // TODO: Currently the only way for a user to switch between programs is from within the program boxes. Hiding them should prevent the ability for state updates
  // If the program 1 window is expired or not yet arrived hide the UI of this program
  if (!program1Enabled) {
    const program1 = document.getElementById('Program-1');
    if (program1) program1.style.display = 'none';
  }

  // If the program 2 window is expired or not yet arrived hide the UI of this program
  if (!program2Enabled) {
    const program2 = document.getElementById('Program-2');
    if (program2) program2.style.display = 'none';
  }    

  // Header Bar & Cart Flyout: Check if a Pre book Program has been activated
  const updateHeaderBarState = () => {
    if (Cookies.get('prebookProgram')) {
      if (isRep && Cookies.get('customerUsePrebook') === 'false') {
        document.body.classList.add('repOrderActive'); // optionally re-enable
        return false;
      }

      if (!Cookies.get('prebookPopupClose')) {
        $prebookPopup.show(); // assuming you still want to use jQuery for this
      }

      $prebookPopup.on('click', '.close-x', () => {
        $prebookPopup.hide();
        Cookies.set('prebookPopupClose', 1, { expires: 1, path: '' });
      });

      const programCookie = Cookies.get('prebookProgramId');
      activeProgram = programCookie || "1";

      const orderCookie = Cookies.get('prebookOrderId');
      activeOrder = orderCookie || 0;

      $prebookBar.addClass('Activated');

      const activeProgramEl = document.getElementById(`Program-${activeProgram}`);
      if (activeProgramEl) activeProgramEl.classList.add('Active');

      document.querySelectorAll('.programActive').forEach(el => {
        el.textContent = activeProgram;
      });

      document.body.classList.add('prebookActive', `activeProgram${activeProgram}`);

      document.querySelectorAll('.pre-book-container').forEach(el => {
        el.classList.remove('Active');
      });

      document.querySelectorAll('.order_number').forEach(el => {
        el.value = activeOrder;
      });

      if (window[`program${activeProgram}Enabled`]) {
        const programObject = window[`program${activeProgram}`];
        const storeObject = window[`storeProgram${activeProgram}`];
        programMax = storeObject?.orderCountMax;

        if (programObject?.orders) {
          activeOrderData = programObject.orders[activeOrder];
        }
      }

      programMax = window[`program${activeProgram}OrderCountMax`];

      document.querySelectorAll('.CurrentTitle').forEach(el => {
        el.textContent = `${liquidVars.ProgramTitle} ${activeProgram}`;
      });

      document.querySelectorAll('.CurrentOrder').forEach(el => {
        el.textContent = parseInt(activeOrder) + 1;
      });

      document.querySelectorAll('.MaxOrder').forEach(el => {
        el.textContent = programMax;
      });

      if (activeOrderData) {
        const { note, poNumber, dateShip /*, dateCancel */ } = activeOrderData;

        document.querySelectorAll('.cart--root').forEach(cartRoot => {
          const cartDates = cartRoot.querySelector('.cartDates');
          if (cartDates) {
            const shipInput = getActiveCartDateInput(cartRoot);
            if (shipInput) shipInput.value = dateShip;

            // Cancel date is commented out
            // const cancelInput = cartDates.querySelector('.dateCancel');
            // if (cancelInput) cancelInput.value = dateCancel;
          }
        });

        // Restore the matching ship-window state from the saved ship date so the cart UI stays aligned.
        if (singleMode && dateShip) {
          restoreSingleModeOrderEditState(dateShip);
        }

        document.querySelectorAll('.cart--notes').forEach(noteEl => {
          const noteTextarea = noteEl.querySelector('.cart--notes--textarea');
          const poInput = noteEl.querySelector('.po_number');
          if (noteTextarea) noteTextarea.value = note;
          if (poInput) poInput.value = poNumber;
        });

      } else {
        document.querySelectorAll('.cart--notes').forEach(noteEl => {
          const noteTextarea = noteEl.querySelector('.cart--notes--textarea');
          const poInput = noteEl.querySelector('.po_number');
          if (noteTextarea) noteTextarea.value = '';
          if (poInput) poInput.value = '';
        });
      }

      // If single-program mode already has a remembered ship window and we are not restoring a saved order, rehydrate the cart state.
      if (singleMode && !activeOrderData && activeShipWindow) {
        syncSingleModeShipWindowUI(activeShipWindow, {
          persist: false,
          preserveDate: true
        });
      }

    } else {
      $prebookBar.removeClass('Activated');
      if (isRep) {
        const cookieCustomerId = Cookies.get('customerId');
        const cookieCustomerName = Cookies.get('customerName');
        const repBarTextEl = document.querySelector('#repBar .prebookOpen');

        if (cookieCustomerId === 'null' || customerID == cookieCustomerId) {
          Cookies.remove('customerName');
          document.body.classList.remove('repOrderActive');
          if (repBarTextEl) repBarTextEl.textContent = 'Select a customer';
        } else {
          document.body.classList.add('repOrderActive');
          if (repBarTextEl) repBarTextEl.textContent = `Ordering in progress for: ${cookieCustomerName}`;
        }
      }      
    }
  }

  updateHeaderBarState();

  // Set the current order cookie
  const setActiveOrder = (orderNumber) => {
    // Keep the in-memory slot and cookie aligned so edit-mode tier checks read the same
    // active order context as the rest of the cart UI.
    activeOrder = Number.parseInt(orderNumber, 10) || 0;
    Cookies.set('prebookOrderId', activeOrder, { expires: 1 });
    Cookies.set('activePrebookOrderId', activeOrder, { expires: 1 });
  };

  // Pre book program state and functions
  // The element clicked on should contain the data attribute of the program (1 or 2)
  // Can optionally take an order ID to determine if a reset to order 1 needs to occur (it does when toggling between programs).
  const setActiveProgram = async (programId, orderId, isCsv = false, isEdit = false) => {
    if (!programId) return false;
    if (isCompletedNonRepPrebook()) return false;

    // Write both cookie namespaces so the legacy cart refresh code and the
    // single_program hydration code can resolve the same active program/order.
    Cookies.set('prebookProgram', true, { expires: 1 });
    Cookies.set('prebookProgramId', programId, { expires: 1 });
    Cookies.set('activePrebookProgram', true, { expires: 1 });
    Cookies.set('activePrebookProgramId', programId, { expires: 1 });

    // Single-program mode should start each new order with a fresh ship-window choice.
    if (singleMode && !isEdit) {
      resetSingleModeShipWindowUI({ clearDate: true });
    }

    // If an order ID is passed, set that active order or default to the first in the program
    setActiveOrder(orderId);

    try {
      // ✅ Wait for cart to fully clear before updating UI
      await Utilities.clearCart(false);
      latestCartTotal = 0;

      // ✅ Update UI after the cart is cleared
      setPrebookUI(true);
      // Keep the baseline in sync after the cart reset without warning the user.
      await refreshSingleModeTierState({ suppressDowngradeAlert: true });

      if (!isCsv && !isEdit) {
        setTimeout(() => {
          window.location.href = '/collections/all';
        }, 300);
      }
    } catch (error) {
      console.error('Error clearing cart:', error);
    }


  };

  // Set the min and max dates allowed for the date input fields
  function cartDatesMinMax() {
    syncCartModeUI();

    const checkoutWrapper = document.getElementById('cartCheckout');
    const checkoutButtonText = checkoutWrapper ? checkoutWrapper.querySelector('.cart-button--text') : null;
    const submitButtons = Array.from(document.querySelectorAll('.submitOrder'));
    const todayString = new Date().toISOString().split('T')[0]; // Format: YYYY-MM-DD
    const savedShipDate = Cookies.get(SHIP_DATE_COOKIE_KEY);
    let dateInputs = [];

    const setCheckoutState = (isDisabled) => {
      if (!checkoutWrapper) return;

      checkoutWrapper.classList.toggle('disabled', isDisabled);
      if (checkoutButtonText) {
        checkoutButtonText.textContent = isDisabled ? 'Select a Ship Date' : 'Checkout';
      }
    };

    const setRepSubmitState = (isDisabled) => {
      submitButtons.forEach((button) => {
        button.classList.toggle('disabled', isDisabled);
        button.closest('.orderSubmit')?.classList.toggle('disabled', isDisabled);

        const submitButtonText = button.querySelector('.save-the-order');
        if (!submitButtonText || button.classList.contains('processing')) return;

        const enabledText = button.dataset.enabledText || 'Submit Order';
        const disabledText = button.dataset.disabledText || 'Select a Ship Date';
        submitButtonText.textContent = isDisabled ? disabledText : enabledText;
      });
    };

    const updateCartActionState = () => {
      if (!dateInputs.length) {
        setCheckoutState(false);
        setRepSubmitState(false);
        return;
      }

      const hasSelectedDate = dateInputs.some(input => input.value && input.value.trim() !== '');
      const shouldDisableActions = !hasSelectedDate;

      setCheckoutState(shouldDisableActions);
      setRepSubmitState(shouldDisableActions);
    };

    const handleDateInputChange = (event) => {
      const rawValue = event.target.value || '';
      const trimmedValue = rawValue.trim();

      if (trimmedValue) {
        Cookies.set(SHIP_DATE_COOKIE_KEY, trimmedValue, { expires: 7 });
      } else {
        clearShipDateCookie();
      }

      updateCartActionState();
    };

    if (!isPrebookSessionActive()) {
      dateInputs = Array.from(document.querySelectorAll('.b2bCart #dateShipB2B'));
      const validSavedShipDate = savedShipDate && savedShipDate >= todayString ? savedShipDate : '';

      if (savedShipDate && !validSavedShipDate) {
        clearShipDateCookie();
      }

      if (!dateInputs.length) {
        setCheckoutState(false);
        setRepSubmitState(false);
        return;
      }

      dateInputs.forEach((dateInput) => {
        dateInput.setAttribute('min', todayString);
        dateInput.removeAttribute('max');

        if (!dateInput.value && validSavedShipDate) {
          dateInput.value = validSavedShipDate;
        }

        if (!dateInput.dataset.checkoutListenerAttached) {
          dateInput.addEventListener('change', handleDateInputChange);
          dateInput.addEventListener('input', handleDateInputChange);
          dateInput.dataset.checkoutListenerAttached = 'true';
        }
      });

      updateCartActionState();
      return;
    }

    syncSingleModeShipDateControls();

    const savedProgram = activePrebookData?.programs?.find((program) => program.programId === 1);
    const activeOrderIndex = Math.max(0, getSingleModeOrderPosition() - 1);
    const savedOrderFromProgram = savedProgram?.orders?.[activeOrderIndex] || null;
    const currentDateValue = document.querySelector('.prebookCart .dateShip')?.value || '';

    const selectedSingleShipWindow = singleMode
      ? inferShipWindowFromDate(
          currentDateValue
          || activeShipWindow
          || activeOrderData?.dateShip
          || savedOrderFromProgram?.dateShip
          || ''
        ) || activeShipWindow || Cookies.get(SHIP_WINDOW_COOKIE_KEY)
      : null;

    updateShipWindowStateLabel(selectedSingleShipWindow);
    updateSingleModeTierMetadata({ trackTierChange: false });

    const dateStart = selectedSingleShipWindow === '2'
      ? program2ShipStart
      : activeProgram === '2'
        ? program2ShipStart
        : program1ShipStart;
    const dateEnd = selectedSingleShipWindow === '2'
      ? program2ShipEnd
      : activeProgram === '2'
        ? program2ShipEnd
        : program1ShipEnd;

    dateInputs = Array.from(document.querySelectorAll(singleMode ? '.prebookCart .dateShip' : '.cart--root .dateShip'));

    const isDateWithinRange = (value) => {
      if (!value) return false;
      if (dateStart && value < dateStart) return false;
      if (dateEnd && value > dateEnd) return false;
      return true;
    };

    if (singleMode && !selectedSingleShipWindow) {
      dateInputs.forEach((dateInput) => {
        dateInput.value = '';
        dateInput.removeAttribute('min');
        dateInput.removeAttribute('max');
      });
      setCheckoutState(true);
      setRepSubmitState(true);
      return;
    }

    const validSavedShipDate = isDateWithinRange(savedShipDate) ? savedShipDate : '';
    if (savedShipDate && !validSavedShipDate) {
      clearShipDateCookie();
    }

    document.querySelectorAll('.cart--root').forEach(cartRoot => {
      const dateInput = cartRoot.querySelector(singleMode ? '.prebookCart .dateShip' : '.dateShip');

      if (dateInput) {
        // Compare today's date to dateStart
        const useToday = new Date(todayString) > new Date(dateStart);
        const selectedValue = useToday ? todayString : dateStart;

        //dateInput.setAttribute('value', selectedValue);
        dateInput.setAttribute('min', selectedValue);
        dateInput.setAttribute('max', dateEnd);

        if (!dateInput.value && validSavedShipDate) {
          dateInput.value = validSavedShipDate;
        }

        if (!dateInput.dataset.checkoutListenerAttached) {
          dateInput.addEventListener('change', handleDateInputChange);
          dateInput.addEventListener('input', handleDateInputChange);
          dateInput.dataset.checkoutListenerAttached = 'true';
        }
      }
    });
    updateCartActionState();
  }

  // Set the date field min and max values in the cart
  cartDatesMinMax();

  // If the cart drawer is re-rendered by Shopify (for example after a quantity change),
  // re-apply the current cart mode so a refresh does not fall back to the wrong date UI.
  syncCartModeUI();

  if (singleMode && isPrebookSessionActive()) {
    refreshSingleModeTierState().finally(() => {
      restoreSingleModeCartState();
    });
  }

  $(window).on('theme.cart.update-complete', () => {
    syncCartModeUI();

    if (singleMode && isPrebookSessionActive()) {
      refreshSingleModeTierState().finally(() => {
        restoreSingleModeCartState();
      });
    } else {
      cartDatesMinMax();
    }
  });
  
  const hidePrebookToolTips = () => {
    const prebookMain = document.querySelector('.b2b-dashboard-main');
    if (!prebookMain) return;

    prebookMain.querySelectorAll('.toolTipTrigger').forEach(trigger => {
      trigger.setAttribute('aria-expanded', 'false');
    });

    prebookMain.querySelectorAll('.tool-tip').forEach(tip => {
      tip.classList.remove('show');
      tip.setAttribute('aria-hidden', 'true');
    });
  };

  /**
   * ✅ NEW VERSION USING Utilities.addProductsToCartCSV
   */
  // Add items to the cart. These items originated from the customer CSV upload as SKU's.
  // They were transformed from SKU's to variant ID's within the Lambda + Shopify API before being returned back to the frontend here.    
  const toArray = (value) => {
    if (Array.isArray(value)) return value;
    return value === undefined || value === null || value === '' ? [] : [value];
  };

  const getCSVItemSku = (item) => {
    if (typeof item === 'string' || typeof item === 'number') {
      return String(item).trim();
    }

    if (!item || typeof item !== 'object') return '';

    return String(
      item.sku
      ?? item.SKU
      ?? item.variantSku
      ?? item.variant_sku
      ?? item.requestedSku
      ?? item.code
      ?? ''
    ).trim();
  };

  const getCSVItemKey = (item) => getCSVItemSku(item).toUpperCase();

  const addCSVRejectionReason = (reasonsBySku, item, reason) => {
    const skuKey = getCSVItemKey(item);
    if (!skuKey) return;

    if (!reasonsBySku.has(skuKey)) reasonsBySku.set(skuKey, new Set());
    reasonsBySku.get(skuKey).add(reason);
  };

  const createCSVUploadContext = (data, originalItems) => {
    const sourceItems = Array.isArray(originalItems) ? originalItems : [];
    const resolvedItems = toArray(data?.items);
    const reasonsBySku = new Map();

    toArray(data?.itemsNotFound).forEach((item) => {
      addCSVRejectionReason(reasonsBySku, item, 'SKU not found');
    });

    toArray(data?.itemsDraft).forEach((item) => {
      addCSVRejectionReason(reasonsBySku, item, 'SKU is not published');
    });

    toArray(data?.itemsUnavailable).forEach((item) => {
      const requested = item && typeof item === 'object' ? item.requested : undefined;
      const available = item && typeof item === 'object' ? item.available : undefined;
      const inventoryDetails = requested !== undefined && available !== undefined
        ? ` (requested ${requested}; available ${available})`
        : '';
      addCSVRejectionReason(
        reasonsBySku,
        item,
        `Insufficient inventory${inventoryDetails}`
      );
    });

    const eligibleRows = sourceItems
      .map((item, index) => ({ item, index, used: false }))
      .filter(({ item }) => {
        const skuKey = getCSVItemKey(item);
        return skuKey && !reasonsBySku.has(skuKey);
      });
    const resolvedSkuKeys = new Set();
    const skuKeysByVariantId = new Map();

    resolvedItems.forEach((item) => {
      const returnedSkuKey = getCSVItemKey(item);
      let sourceRow = null;

      if (returnedSkuKey) {
        sourceRow = eligibleRows.find(({ item: sourceItem, used }) => {
          return !used && getCSVItemKey(sourceItem) === returnedSkuKey;
        });
      }

      if (!sourceRow) sourceRow = eligibleRows.find(({ used }) => !used);
      if (sourceRow) sourceRow.used = true;

      const skuKey = returnedSkuKey || getCSVItemKey(sourceRow?.item);
      if (!skuKey) return;

      resolvedSkuKeys.add(skuKey);

      const variantId = String(item?.id ?? '');
      if (variantId) {
        if (!skuKeysByVariantId.has(variantId)) {
          skuKeysByVariantId.set(variantId, new Set());
        }
        skuKeysByVariantId.get(variantId).add(skuKey);
      }
    });

    sourceItems.forEach((item) => {
      const skuKey = getCSVItemKey(item);
      if (skuKey && !reasonsBySku.has(skuKey) && !resolvedSkuKeys.has(skuKey)) {
        addCSVRejectionReason(reasonsBySku, item, 'SKU was not returned for cart addition');
      }
    });

    return {
      originalItems: sourceItems,
      reasonsBySku,
      skuKeysByVariantId,
    };
  };

  const buildRejectedCSVRows = (uploadContext, cartFailures = []) => {
    const { originalItems, reasonsBySku, skuKeysByVariantId } = uploadContext;

    cartFailures.forEach(({ errorMessage, item }) => {
      const skuKeys = skuKeysByVariantId.get(String(item?.id ?? '')) || [];
      skuKeys.forEach((skuKey) => {
        if (!reasonsBySku.has(skuKey)) reasonsBySku.set(skuKey, new Set());
        reasonsBySku.get(skuKey).add(
          `Shopify could not add this SKU to the cart: ${errorMessage}`
        );
      });
    });

    return originalItems.reduce((rows, item, index) => {
      const sku = getCSVItemSku(item);
      const reasons = sku
        ? reasonsBySku.get(getCSVItemKey(item))
        : new Set(['Blank SKU']);

      if (reasons?.size) {
        rows.push({
          row: index + 1,
          sku,
          quantity: item?.quantity ?? '',
          reason: Array.from(reasons).join('; '),
        });
      }

      return rows;
    }, []);
  };

  const escapeCSVDownloadCell = (value) => {
    let cell = String(value ?? '');
    if (/^[=+\-@]/.test(cell)) cell = `'${cell}`;
    return `"${cell.replace(/"/g, '""')}"`;
  };

  const downloadRejectedCSV = (rows) => {
    const csvRows = [
      ['Row', 'SKU', 'Quantity', 'Reason'],
      ...rows.map(({ row, sku, quantity, reason }) => [row, sku, quantity, reason]),
    ];
    const csv = csvRows
      .map((row) => row.map(escapeCSVDownloadCell).join(','))
      .join('\r\n');
    const blob = new Blob([`\uFEFF${csv}`], { type: 'text/csv;charset=utf-8' });
    const downloadUrl = URL.createObjectURL(blob);
    const link = document.createElement('a');

    link.href = downloadUrl;
    link.download = `rejected-skus-${new Date().toISOString().slice(0, 10)}.csv`;
    link.style.display = 'none';
    document.body.appendChild(link);
    link.click();
    link.remove();
    setTimeout(() => URL.revokeObjectURL(downloadUrl), 0);
  };

  const setRejectedCSVDownload = (rows) => {
    const downloadPanel = document.getElementById('rejectedSkuDownload');
    const downloadButton = document.getElementById('downloadRejectedSkus');
    if (!downloadPanel || !downloadButton) return;

    downloadPanel.hidden = rows.length === 0;
    downloadButton.onclick = rows.length > 0
      ? () => downloadRejectedCSV(rows)
      : null;
  };

  const addSkusToCart = (data, originalItems = []) => {
    const itemsToAdd = toArray(data?.items);
    const uploadContext = createCSVUploadContext(data, originalItems);
    const permanentCartFailures = [];

    console.log(`🚀 Adding ${itemsToAdd.length} items via Utilities.addProductsToCartBatched...`);

    // ✅ Map CSV items to Shopify /cart/add.js format
    const productQueue = itemsToAdd.map((item) => ({
      id: item.id,
      quantity: item.quantity,
    }));

    // ✅ Call the shared batch-based cart helper used by both CSV imports and edit rehydrates.
    Utilities.addProductsToCartBatched(
      productQueue,
      (finalCart) => {
        console.log("✅ Final cart state:", finalCart);
        handleCSVComplete(finalCart, permanentCartFailures, data, uploadContext);
      },
      (errorMessage, failedBatch) => {
        console.warn(
          `⚠️ Failed batch (skipped items):`,
          failedBatch,
          "Reason:",
          errorMessage
        );
      },
      20, // ✅ Recommended batch size for CSV uploads (adjustable)
      5,
      (errorMessage, failedItems) => {
        failedItems.forEach((item) => {
          permanentCartFailures.push({ errorMessage, item });
        });
      }
    );
  };

  // Handle success of adding SKU's to cart. SKU's were already converted to Variant Id's via Lambda at this point.
  const handleCSVComplete = (finalCart, skippedItems, data, uploadContext) => {
    console.log("✅ Final cart state:", finalCart);
    console.log("🔍 CSV data received:", data);

    // ✅ Use the program & order cookies to associate the data
    const programIdForCookie = Cookies.get('prebookProgramId');
    const orderIdForCookie = Cookies.get('prebookOrderId');
    const csvCookieKey = `prebookPendingCSV_${programIdForCookie}_${orderIdForCookie}`;

    // TODO: itemsNoQty code can be uncommented if you want to display insufficient quantity items in the CSV upload feedback modal. Look for other instances to uncomment including within theme.liquid.
    Cookies.set(
      csvCookieKey,
      JSON.stringify({
        itemsNotFound: data.itemsNotFound || [],
        itemsDraft: data.itemsDraft || []
        //itemsNoQty: data.itemsUnavailable || []
      }),
      { expires: 1, path: '' }
    );

    console.log(`✅ Stored CSV data for future save in ${csvCookieKey}`);

    if (finalCart) {
      latestCartTotal = Number(finalCart.total_price || 0);
      updateSingleModeTierMetadata({ trackTierChange: false });
    }

    // ----- Existing UI updates -----
    // TODO: itemsNoQty, noQty and if(noQty)... code can be uncommented if you want to display insufficient quantity items in the CSV upload feedback modal. Look for other instances to uncomment including within theme.liquid.
    const mainHeading = document.getElementById('csv-loader-heading');
    const successCount = document.getElementById('successfulItems');
    const notFound = document.getElementById('itemsNotFound');
    const notAvailable = document.getElementById('itemsNotAvailable');
    //const noQty = document.getElementById('itemsNoQuantity');

    let itemsNotFound = 'All SKUs were found in the store.';
    let itemsNotAvailable = 'All SKUs are published in the store.';
    //let itemsNoQty = "All SKU's have enough quantity to fulfill the request.";

    const rejectedCSVRows = buildRejectedCSVRows(uploadContext, skippedItems);
    setRejectedCSVDownload(rejectedCSVRows);

    if (mainHeading) mainHeading.innerHTML = "Your skus are ready!";
    if (successCount) successCount.innerHTML = data.itemCount;

    if (notFound) {
      if (data.itemsNotFound.length > 0) itemsNotFound = data.itemsNotFound;
      notFound.innerHTML = itemsNotFound;
    }

    if (notAvailable) {
      if (data.itemsDraft.length > 0) itemsNotAvailable = data.itemsDraft;
      notAvailable.innerHTML = itemsNotAvailable;
    }

    // if (noQty) {
    //   // Clear any existing content first (optional)
    //   noQty.innerHTML = '';

    //   if (data.itemsUnavailable && data.itemsUnavailable.length > 0) {
    //     data.itemsUnavailable.forEach(item => {
    //       const itemDiv = document.createElement('div');
    //       itemDiv.classList.add('no-qty-item'); // Optional class for styling

    //       // Format the content
    //       itemDiv.innerHTML = `${item.sku} had a request of ${item.requested}. Only ${item.available} available.`;

    //       // Append to the #noQty container
    //       noQty.appendChild(itemDiv);
    //     });
    //   } else {
    //     noQty.innerHTML = itemsNoQty;
    //   }
    // }

    showCSVLoadingReady();
    handleCSVLoadingClose();
  };    

  // After the CSV has processed, user needs to close the upload status modal. Closing this kicks off the next event in the flow.
  const handleCSVLoadingClose = () => {
    const closeCSVLoader = document.getElementById('closeCSVLoader');
    closeCSVLoader.addEventListener('click', function(){
      forceRefresh(true);
    });
  }

  // Prebook CSV upload. Handles adding products into the user's cart from CSVs.
  const parseCSV = (text) => {
    return text
      .trim()
      .split('\n')
      .map(line => {
        const [rawSku, rawQty] = line.split(',');
        const sku = rawSku?.trim() || '';
        const quantity = parseInt(rawQty?.trim(), 10);
        return {
          sku,
          quantity: isNaN(quantity) ? 1 : quantity
        };
      });
  };

  // CSV upload has initialized. Show a loading screen.
  const showCSVLoadingScreen = () => {
    const csvLoadingPanel = document.getElementById('CSVLoaderModal');
    csvLoadingPanel.classList.add('Show');
  }

  // The CSV upload is complete. User must close the loading screen.
  // The loading screen provides instructions to the user for next steps. That is why we have them manually close this screen so they actually look at the instructions.
  const showCSVLoadingReady = () => {
    const csvLoadingPanel = document.getElementById('csvLoadReady');
    csvLoadingPanel.classList.add('Show');
  }

  const submitCSVUpload = (e, form, msg) => {
    if (form) {
      e.preventDefault();
      const fileInput = form.querySelector('input[type="file"]');
      const file = fileInput?.files?.[0];
      const csvMsg = document.getElementById('csvLoaderMsg');

      if(csvMsg && msg) csvMsg.innerHTML = msg;

      if (!file) {
        alert("Please upload a CSV file.");
        return;
      }

      const reader = new FileReader();

      reader.onload = (event) => {
        const text = event.target.result;
        const items = parseCSV(text);
        const csvBody = {
          type: "csv_upload",
          items,
          source: "frontend-upload",
          timestamp: new Date().toISOString()
        };
        showCSVLoadingScreen();
        runApiQuery(
          prebookEndpoint,
          csvBody,
          (data) => addSkusToCart(data, items),
          false
        );
      };

      reader.onerror = () => {
        alert("Failed to read file.");
      };

      reader.readAsText(file);
    }
  }
  
  // Close the program and return to standard shipping flow
  document.querySelectorAll('.CloseProgram').forEach(button => {
    button.addEventListener('click', () => {
      Cookies.remove('prebookProgram');
      Cookies.remove('prebookProgramId');
      Cookies.remove('prebookOrderId');
      Cookies.remove('customerName');
      Cookies.remove('customerId');
      Cookies.remove('customerUsePrebook');

      Utilities.clearCart();
    });
  });

  // Rep customer select
  document.querySelectorAll('.customer--root').forEach(root => {
    root.addEventListener('click', (e) => {
      const target = e.target;
      
      if (target.closest('.rep-drop-select button')) {
        const button = target.closest('.rep-drop-select button');
        e.preventDefault();

        const customerId = parseInt(button.dataset.value, 10);
        let cartConfirm = true;

        if (button.classList.contains('Selected')) return false;

        const hasCartItems = document.querySelectorAll('.cart--form .cart--item').length > 0;

        if (hasCartItems) {
          cartConfirm = confirm("Items in your cart will be removed. Are you sure you want to continue?");
        } else {
          const loader = document.querySelector('.prebookSelectCustomer');
          if (loader) loader.classList.add('Show');

          const siblings = button.parentElement.querySelectorAll('button');
          siblings.forEach(sib => sib.classList.remove('Selected'));
          button.classList.add('Selected');
        }

        Cookies.set('customerId', customerId);
        Cookies.set('customerName', button.textContent.trim());

        if (cartConfirm) {
          Utilities.clearCart();
        }
      }
    });
  });

  // Save an order from cart
  document.querySelectorAll('.cart--root').forEach(cartRoot => {
    cartRoot.addEventListener('click', (e) => {
      const saveButton = e.target.closest('.saveOrder');
      if (!saveButton) return;

      const formRoot = saveButton.closest('.cart--root');
      if (!formRoot) return;

      const formDateShip = getActiveCartDateInput(formRoot)?.value || '';
      // const formDateCancel = formRoot.querySelector('.cartDates .dateCancel')?.value || ''; // If needed
      const formNote = formRoot.querySelector('.cart--notes--textarea')?.value || '';
      const formPO = formRoot.querySelector('.po_number')?.value || '';

      orderSave(activeProgram, activeOrder, formDateShip, formNote, formPO);
    });
  });

  // Submit an order to the API directly from the cart (Rep Order outside of Prebook)
  document.querySelectorAll('.cart--root').forEach(cartRoot => {
    cartRoot.addEventListener('click', (e) => {
      const submitButton = e.target.closest('.submitOrder');
      if (!submitButton) return;

      const formRoot = submitButton.closest('.cart--root');
      if (!formRoot) return;

      const formDateShip = getActiveCartDateInput(formRoot)?.value || '';
      // const formDateCancel = formRoot.querySelector('.cartDates .dateCancel')?.value || ''; // Optional
      const formNote = formRoot.querySelector('.cart--notes--textarea')?.value || '';
      const formPO = formRoot.querySelector('.po_number')?.value || '';

      if (submitButton.classList.contains('disabled') || !formDateShip.trim()) {
        return;
      }

      // Reps placing non-prebook orders submit to Program 1 / Order 1 (i.e., 0-indexed).
      repOrderSubmit(0, 0, formDateShip, formNote, formPO);
    });
  });

  if (accountCsvUploadForm) {
    accountCsvUploadForm.addEventListener('submit', async (e) => {
      const form = e.target;
      submitCSVUpload(e, form, liquidVars.skusLoadingB2B);
    });
  }

  // Ship-window controls only exist in single_program mode and should not affect the legacy path.
  // This listener must be attached before any early returns so the cart UI works even when the account template is absent.
  document.addEventListener('click', (e) => {
    if (!singleMode) return;

    const shipWindowBtn = e.target.closest('.ship-window-button');
    if (shipWindowBtn) {
      e.preventDefault();

      const shipWindowId = shipWindowBtn.getAttribute('data-ship-window') || '1';
      syncSingleModeShipWindowUI(shipWindowId, {
        persist: true,
        preserveDate: false
      });

      return;
    }

    const shipWindowResetBtn = e.target.closest('.ship-window-reset');
    if (shipWindowResetBtn) {
      e.preventDefault();
      resetSingleModeShipWindowUI({ clearDate: true });
    }
  });

  const programHandlebarTemplate = document.getElementById('program-handlebar-template');
  if (!programHandlebarTemplate) return;

  // Hide all tool tips on mouse leave of main container
  programHandlebarTemplate.addEventListener('mouseleave', hidePrebookToolTips);

  // Mouse enter on .AccContentPre inside container
  programHandlebarTemplate.addEventListener('mouseenter', (e) => {
    if (e.target.closest('.AccContentPre')) {
      hidePrebookToolTips();
    }
  });

  // Init prebook order
  programHandlebarTemplate.addEventListener('click', (e) => {
    const initBtn = e.target.closest('.prebookInit');
    if (initBtn) {
      e.stopPropagation();
      if (initBtn.classList.contains('restricted')) return false;

      const programId = initBtn.getAttribute('data-prebook-program');
      if (activePrebookData) {
        const program = activePrebookData.programs.find(p => p.programId == programId);
        const nextOrderId = program?.orders.length || 0;
        setActiveProgram(programId, nextOrderId, false, false);
      } else {
        alert('Sorry...No data was retrieved from the customer metafield.');
      }
    }
  });

  // Init CSV toggle
  programHandlebarTemplate.addEventListener('click', (e) => {
    const csvBtn = e.target.closest('.prebookInitCSV');
    if (csvBtn) {
      e.stopPropagation();
      if (csvBtn.classList.contains('restricted')) return false;

      const formId = csvBtn.getAttribute('data-form');
      const form = document.getElementById(formId);

      hidePrebookToolTips();

      const isActive = csvBtn.classList.toggle('active');
      csvBtn.setAttribute('aria-expanded', isActive ? 'true' : 'false');
      if (form) {
        form.classList.toggle('show', isActive);
        form.setAttribute('aria-hidden', isActive ? 'false' : 'true');
      }

      const programId = csvBtn.getAttribute('data-prebook-program');
      if (activePrebookData) {
        const program = activePrebookData.programs.find(p => p.programId == programId);
        const nextOrderId = program?.orders.length || 0;
        setActiveProgram(programId, nextOrderId, true, false);
      } else {
        alert('Sorry...No data was retrieved from the customer metafield.');
      }
    }
  });    

  // Accordion toggle
  programHandlebarTemplate.addEventListener('click', (e) => {
    const accBtn = e.target.closest('.prebookAcc');
    if (accBtn && !e.target.classList.contains('prebookInit')) {
      hidePrebookToolTips();
      const accId = accBtn.getAttribute('data-prebook-acc');
      const accEl = document.getElementById(accId);
      if (!accEl) return;

      accBtn.classList.toggle('Active');
      if (accBtn.classList.contains('Active')) {
        accEl.style.display = 'block';
      } else {
        accEl.style.display = 'none';
      }
    }
  });

  // Edit order
  programHandlebarTemplate.addEventListener('click', (e) => {
    const editBtn = e.target.closest('.EditOrder');
    if (editBtn) {
      e.preventDefault();
      const orderId = editBtn.getAttribute('data-order');
      const programId = editBtn.getAttribute('data-prebook-program');
      prebookProgramOrderEdit(programId, orderId);
    }
  });

  // Disclaimer toggle
  programHandlebarTemplate.addEventListener('click', (e) => {
    const trigger = e.target.closest('.disclaimerTrigger');
    if (trigger) {
      const submitConfirmEls = document.querySelectorAll('.submitConfirm');
      if (trigger.classList.contains('active')) {
        trigger.style.display = '';
        submitConfirmEls.forEach(el => el.classList.remove('Show'));
      } else {
        trigger.style.display = 'none';
        submitConfirmEls.forEach(el => el.classList.add('Show'));
      }
    }
  });

  // Submit program orders
  programHandlebarTemplate.addEventListener('click', (e) => {
    const submitBtn = e.target.closest('.SubmitOrders');
    if (submitBtn) {
      e.preventDefault();
      if (isCompletedNonRepPrebook()) return false;

      const programId = submitBtn.getAttribute('data-program');
      const program = activePrebookData.programs.find(p => p.programId == programId);
      if (program) program.state = 'complete';
      prebookProgramSubmit(programId);
    }
  });

  // Remove order
  programHandlebarTemplate.addEventListener('click', (e) => {
    const removeBtn = e.target.closest('.OrderRemove');
    if (removeBtn) {
      const orderId = removeBtn.getAttribute('data-orderNumber');
      const container = removeBtn.closest('.pre-book-container');
      const programId = container?.id.replace('Program-', '');
      const orderEl = removeBtn.closest('.pre-book-order');
      if (orderEl) {
        orderEl.innerHTML = '<p>Deleting order. Please allow a few moments for your account to update.</p>';
        prebookProgramOrderDelete(programId, orderId);
      }
    }
  });

  // CSV upload (Prebook)
  programHandlebarTemplate.addEventListener('submit', async (e) => {
    const form = e.target.closest('.csv-upload-form');
    if (isCompletedNonRepPrebook()) {
      e.preventDefault();
      return false;
    }
    submitCSVUpload(e, form, liquidVars.skusLoadingPrebook);
  });

  // CSV upload (B2B)
  b2bCsvUploadForm.addEventListener('submit', async (e) => {
    const form = e.target;
    submitCSVUpload(e, form, liquidVars.skusLoadingB2B);
  });

  // Tooltip reveal
  programHandlebarTemplate.addEventListener('mouseenter', (e) => {
    const trigger = e.target.closest('.toolTipTrigger');
    if (trigger) {
      hidePrebookToolTips();
      const tooltipId = trigger.getAttribute('aria-controls');
      const tooltip = document.getElementById(tooltipId);
      trigger.setAttribute('aria-expanded', 'true');
      if (tooltip) {
        tooltip.classList.add('show');
        tooltip.setAttribute('aria-hidden', 'false');
      }
    }
  }, true);

  // Tooltip hide
  programHandlebarTemplate.addEventListener('mouseleave', (e) => {
    if (e.target.closest('.tool-tip')) {
      hidePrebookToolTips();
    }
  });

  // Cancel submit
  programHandlebarTemplate.addEventListener('click', (e) => {
    const cancelBtn = e.target.closest('.CancelSubmit');
    if (cancelBtn) {
      document.querySelectorAll('.disclaimerTrigger').forEach(el => {
        el.style.display = '';
      });
      document.querySelectorAll('.submitConfirm').forEach(el => {
        el.classList.remove('Show');
      });
    }
  });

  // Sometimes when the window is force refreshed the cart should be displayed immediately after screen loads.
  // This is so customer can see the new activity that just happened in their cart which occurred as a result of the refresh.
  if (Cookies.get('openCart') === 'true') {
    window.addEventListener('load', () => {
      const isMobile = window.innerWidth < 1024;
      const cartButton = document.querySelector(
        isMobile
          ? '.header--mobile--cart .header--cart-link'
          : '.header--desktop--cart .header--cart-link'
      );

      if (cartButton) cartButton.click();

      Cookies.remove('openCart');
    });
  } 

  // Pre-book instructional content panel
  const triggerPrebookInstructions = document.getElementById('triggerPrebookInstructions');
  const panelPrebookInstructions = document.getElementById('panelPrebookInstructions');
  const b2bCsvUpload = document.getElementById('panelB2bCsvUpload');
  const setPanelState = (panel, isVisible) => {
    if (!panel) return;
    panel.style.display = isVisible ? 'block' : 'none';
    panel.setAttribute('aria-hidden', isVisible ? 'false' : 'true');
  };

  const setTriggerState = (trigger, isActive) => {
    if (!trigger) return;
    trigger.classList.toggle('active', isActive);
    trigger.setAttribute('aria-expanded', isActive ? 'true' : 'false');
  };

  const showDashboardPanel = (panelName = null) => {
    const showInstructions = panelName === 'instructions';
    const showCsv = panelName === 'csv';

    setPanelState(panelPrebookInstructions, showInstructions);
    setPanelState(b2bCsvUpload, showCsv);

    setTriggerState(triggerPrebookInstructions, showInstructions);
    setTriggerState(triggerB2bCsvUpload, showCsv);

    if (panelPrebookTools) {
      panelPrebookTools.classList.toggle('hide', showCsv);
    }
  };

  if (triggerB2bCsvUpload && b2bCsvUpload) {
    triggerB2bCsvUpload.addEventListener('click', () => {
      const isVisible = b2bCsvUpload.style.display !== 'none';
      showDashboardPanel(isVisible ? null : 'csv');
    });
  }

  if (triggerPrebookInstructions && panelPrebookInstructions) {
    triggerPrebookInstructions.addEventListener('click', () => {
      const isVisible = panelPrebookInstructions.style.display !== 'none';
      showDashboardPanel(isVisible ? null : 'instructions');
    });

    // If Prebook not yet initialized, show the instructions by default
    // const customerUsePrebook = Cookies.get('customerUsePrebook');
    // if (!customerUsePrebook || customerUsePrebook === 'false') {
    //   triggerPrebookInstructions.classList.add('active');
    //   panelPrebookInstructions.style.display = 'block';
    // }
  }

};

Lemonade.accordions = function(){
  var $accTrigger = $('.AccTrigger'),
      $acc = $('.AccContent');

  // Accordion content    
  $accTrigger.click(function(e){
    e.preventDefault();
    var $me = $(this),
        $content = $me.next('.AccContent');
        
    $acc.slideUp();
    if ($me.hasClass('Open')){
        $me.removeClass('Open');
        return false;
    }
    $accTrigger.removeClass('Open');
    $me.addClass('Open');
    $content.slideToggle();
  });
};

Lemonade.chatModule = function(){
    var $chatModule = $('#chat-module');
    $('.ChatTrigger').on('click', function(){
        $chatModule.toggleClass('Active');
    });
    $('.ChatClose').on('click', function(){
        $chatModule.toggleClass('Active');
    });
};

Lemonade.promiseDate = function(){
  // Need to determine if a Physyx product is in the cart
  $.getJSON('/cart.js', function(cart){
    let hasPhysyx = false;
    let options = {
      timeZone: 'America/New_York',
      year: 'numeric',
      month: 'numeric',
      day: 'numeric',
    },
    formatter = new Intl.DateTimeFormat([], options);
    let currentDate = new Date(formatter.format(new Date()));
    // let currentDay = currentDate.getDay();
    let minDate = currentDate;
    // This date specified by client for Physyx products earliest shipping
    let futureDate = futureDateVars.futureDate ? new Date(formatter.format(new Date(futureDateVars.futureDate))) : null;
    switch (currentDate.getDay()) {
      case 0:
      case 1:
      case 2:
        minDate.setDate(currentDate.getDate() + 3);
        break;
      case 6:
        minDate.setDate(currentDate.getDate() + 4);
        break;
      case 5:
      case 4:
      case 3:
        minDate.setDate(currentDate.getDate() + 5);
        break;
    }
    // Check for a Physyx product
    $.each(cart.items, function(i, el){
      if(el.handle.includes(futureDateVars.futureShipProducts)){
        hasPhysyx = true;
        return false;
      }
    });
    // If cart has a Physyx product set the date picker to a specific future date
    if(futureDate && hasPhysyx && currentDate < futureDate){
      minDate = futureDate
    }
    const settings = {
      minDate: minDate,
      field: document.getElementById('promiseDate'),
      format: 'MM-DD-YYYY',
      toString(date, format) {
          const day = date.getDate();
          const month = ('0' + (date.getMonth() + 1)).slice(-2);
          const year = date.getFullYear();
          return `${month}-${day}-${year}`;
      },
      disableDayFn: function(dateTime){
          /* here you can access each day shown and disable those in your range. To disable just return true*/
        if (dateTime.getDay() == 0 || dateTime.getDay() == 6) {
          return true
        } else {
          return false
        }
      }
    }

    datePicker = new Pikaday(settings);
    datePicker.gotoMonth(minDate.getMonth());
    datePicker.gotoYear(minDate.getFullYear());
  });
}

// Initialize Lemonade JS on docready
$(Lemonade.init);

$(document).ready(function () {
  //check when click on reorder button.
  $("#reorder-button").on("click", function (e) {
    e.preventDefault();
    $(".order--subtotal").addClass("hidden");
    $(".order--discount--terms").addClass("hidden");
    $(".order--shipping-data").addClass("hidden");
    $(".order--delar--terms").addClass("hidden");
    $(".order--total--terms").addClass("hidden");
    $(".order--item--quantity").addClass("hidden");
    $(".order--reorder--subtotal").removeClass("hidden");
    $(".reorder--item--quantity").removeClass("hidden");
    $("#addtocart-button").removeClass("hidden");
    $(this).addClass("hidden");
    setProductPrices();
  });

  // function for set the values of reorder page
  function setProductPrices() {
    var totalLinePrice = 0;
    $(".reorder-item-id").each(function (el) {
      var linePrice = $(this)
        .find(".order--item--price")
        .attr("data-line-item-price");
      linePrice = linePrice * $(this).find('[name="quantity"]').val();
      $(this)
        .find(".order--item--total")
        .html(theme.utils.formatMoney(linePrice));
      totalLinePrice += linePrice;
    });
    $(".order--reorder--subtotal .order--item--total").html(
      theme.utils.formatMoney(totalLinePrice)
    );
  }

  //function for when someone click on add to cart button of reorder page.
  $("#addtocart-button").on("click", function (e) {
    e.preventDefault();
    var items = [];
    var productTitle;
    $(".reorder-item-id").each(function (el) {
      var quantity = $(this).find('[name="quantity"]').val();
      productTitle = $(this).children().find("a").text();

      if (quantity != 0) {
        items.push({ id: $(this).attr("data-pr-id"), quantity: quantity });
      }
    });
    if (items.length > 0) {
      let formData = {
        items: items,
      };
      fetch("/cart/add.js", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(formData),
      })
        .then((response) => {
          if (response.ok) {
            window.location.href = "/cart";
          } else {
            alert("The Product " + productTitle + " is already Sold Out");
          }
        })
        .catch((error) => {
          console.error("Error:", error);
        });
    }
  });

  // function whenever product order qty will change
  $('[name="quantity"]').on("change", function () {
    setProductPrices();
  });

  $(".product-form--add-to-cart").attr("disabled", true);
  if ($(".template-product")) {
    $("html, body").animate({ scrollTop: 0 }, "slow");
  }

  $(".off-canvas--overlay").click(function () {
    if ($(".off-canvas--right-sidebar").hasClass("showFlyout")) {
      $(".off-canvas--right-sidebar").removeClass("showFlyout");
      $(".off-canvas--overlay").hide().css("opacity", "0");
      $(".product-form--add-to-cart").attr("disabled", true);
      $("html, body").animate({ scrollTop: 0 }, "slow");
    }
  });

  $(".cart-count").text("0 items");

  // set var to avoid calling jQuery selector function each time
  const $allQty = $(".Quantity");

  // on change of each quantity item, update totals

  $allQty.on("change", function () {
    // set defaults
    let totalPrice = 0;
    let totalQty = 0;

    // loop through all and set total and quantity values
    $allQty.each((i, o) => {
      const $this = $(o),
        thisQty = parseInt($this.val(), 10);

      totalPrice += $this.val() * parseInt($this.attr("data-price"), 10);
      totalQty += thisQty;
    });

    // set language in UI element
    $(".cart-count").text(totalQty + " items for $" + totalPrice);
  });

  $(".product-form--add-to-cart").attr("disabled", false);

  const productQueue = [];
  $(".product-form--container").submit(function (e) {
    e.preventDefault();
    // loop through all and set total and quantity values
    $allQty.each((i, o) => {
      const $this = $(o),
        thisQty = parseInt($this.val(), 10);

      // create the queue object for adding multiple products to cart, if the item has a non-zero quantity
      thisQty &&
        productQueue.push({
          id: $this.attr("data-id"),
          quantity: thisQty,
        });
    });
    Utilities.addProductsToCart(productQueue, null);
  });
});
